﻿'use strict';

var Artcloud = {
    _localHostname: 'localhost',
    _qaHostname: 'pro-qa.artcloud.com',
    _prodHostname: 'pro.artcloud.com',

    get _hostname() { return typeof(window) !== "undefined" && window.location.hostname },
    get _origin() { return typeof(window) !== "undefined" && window.location.origin },

    get isLocal() {
        return this._hostname === this._localHostname;
    },
    get isQa() {
        return this._hostname === this._qaHostname;
    },
    get isProd() {
        return this._hostname === this._prodHostname;
    },

    get cookieDomain() {
        return this.isLocal ? this._hostname : '.artcloud.com';
    },

    get shouldTargetDevApi() {
        return this.isLocal || this._hostname === this._qaHostname ? true : false;
    },

    get googleFontsApiKey() {
        return 'AIzaSyCE7QCLvlrNDJOwGy-WDlveEkY39Q-TeGI'
    },

    get mailchimpClientId() {
        return this.isProd ? '457515153288' : this.isQa ? '927352456422' : '248999181320';
    },

    get mailchimpOnboardingUri() {
        const encodedRedirectUri = encodeURIComponent(Artcloud.mailchimpRedirectUri);
        return `https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=${Artcloud.mailchimpClientId}&redirect_uri=${encodedRedirectUri}&provider=mailchimp`;
    },

    get mailchimpRedirectUri() {
        return `${this.isProd ? 'https://pro.artcloud.com' : this.isQa ? 'https://pro-qa.artcloud.com' : 'http://127.0.0.1:5001'}/?provider=mailchimp`;
    },

    get stripeClientId() {
        // Stripe Express
        return this.shouldTargetDevApi ? 'ca_CZpW0GJp9rIxlnJzK4o61hzN6wndmj1u' : 'ca_CZpWMRgqPFB4eFiaw0jtXIpL0bjWeMd3';
    },

    googleFontsApiUrl() {
        return `https://www.googleapis.com/webfonts/v1/webfonts`;
    },

    knowledgeBaseUrl(path) {
        return `https://help.artcloud.com/knowledge${path ? `/${path}` : ''}`;
    },

    stripeOnboardingUri(business_name = null, email = null, first_name = null, last_name = null, phone_number = null, type = null) {
        // Stripe Standard
        const stripeClientId = Artcloud.shouldTargetDevApi ? 'ca_8W6gFJgzBHcDM5Ca2cMlFRmJKFEcxpsM' : 'ca_8W6gXF2xxHieKMPSSQeN8rTwQu4nu0dr';
        var business_type = 'individual';
        if (type === 3) {
            business_type = 'company';
        }
        const uri = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${stripeClientId}&scope=read_write&provider=stripe&stripe_user[business_name]=${business_name}&stripe_user[business_type]=${business_type}&stripe_user[email]=${email}&stripe_user[first_name]=${first_name}&stripe_user[last_name]=${last_name}&stripe_user[phone_number]=${phone_number}`;
        return uri;
    },

    stripePublishKey(isStripeExpress = false) {
        if (isStripeExpress) {
            return this.shouldTargetDevApi ? 'pk_test_Q3QiHf3D7OO3rIfSP1gptTq9' : 'pk_live_zRbsRK6XVFaDpSVMtUza1sOc';
        }
        return this.shouldTargetDevApi ? 'pk_test_WBrxX2XzWPoxgozmQsNkVBPW' : 'pk_live_QY3xjVaVbkP1I8RedWERJoXd';
    },

    googleOnboardingUri(userIdHash) {
        //https://developers.google.com/identity/protocols/OAuth2UserAgent
        const scope = [
            'https://www.googleapis.com/auth/userinfo.email',
            'https://www.googleapis.com/auth/gmail.readonly',
            'https://www.googleapis.com/auth/gmail.send'
        ];
        const encodedScope = encodeURIComponent(scope.join(' '));
        const host = encodeURIComponent(`${this._origin}/?provider=google`);
        return `https://accounts.google.com/o/oauth2/v2/auth?scope=${encodedScope}&access_type=offline&include_granted_scopes=true&redirect_uri=${host}&response_type=code&client_id=910366990062-91v8ne9q3ndsgn9dv1209f7mlprp7pkh.apps.googleusercontent.com&state=${userIdHash}`;
    },

    get microsoftOnboardingUri() {
        //https://docs.microsoft.com/en-us/azure/active-directory/develop/v1-protocols-oauth-code
        const scope = [
            'https://graph.microsoft.com/Mail.ReadWrite',
            'https://graph.microsoft.com/Mail.Send',
            'offline_access',
            'https://graph.microsoft.com/User.Read'
        ];
        const encodedScope = encodeURIComponent(scope.join(' '));
        const host = encodeURIComponent(`${this._origin}`);
        return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=837eb1ba-f7d7-4be9-9414-2076ed24ae11&response_type=code&redirect_uri=${host}&response_mode=query&scope=${encodedScope}&state=microsoft`;
    },

    quickBooksOnboardingUri(accountId) {
        const clientId = this.shouldTargetDevApi ? 'AB8Fo0n6wJA9Rm9fAMpDZmiPz9Iu2VYMLc18olea6UAdsJoSjm' : 'AB0rE83z6qjXmHk7BDCPkbR0HFSCrhBW6lOugpb9F9cFFFe2ys';
        const redirectUri = this.shouldTargetDevApi ? 'https://pro-qa.artcloud.com/oauth/quickbooks' : 'https://pro.artcloud.com/oauth/quickbooks';
        //const redirectUri = this.shouldTargetDevApi ? 'https://localhost:5001/oauth/quickbooks' : 'https://pro.artcloud.com/oauth/quickbooks';
        return `https://appcenter.intuit.com/connect/oauth2?client_id=${clientId}&response_type=code&scope=com.intuit.quickbooks.accounting&redirect_uri=${redirectUri}&state=${accountId}`;
    },

    constantContactOnboardingUri(accountId) {
        const redirectUri = `${this._getRedirectUri()}/constantContact`;
        return `https://authz.constantcontact.com/oauth2/default/v1/authorize?client_id=da213ead-f3cd-4cb9-9d9c-1517473bc6c5&redirect_uri=${redirectUri}&response_type=code&scope=contact_data&state=${accountId}`;
    },

    _getRedirectUri() {
        return `${this.isProd ? 'https://pro.artcloud.com' : this.isQa ? 'https://pro-qa.artcloud.com' : 'https://localhost:5001'}/oauth`;
    },

    get artsyOnboardingUri() {
        const redirectUri = encodeURIComponent(`${this._getRedirectUri()}/artsy`);
        const rootUri = this.isProd ? 'api.artsy.net' : 'stagingapi.artsy.net';
        const clientId = this.isProd ? 'ef6d05144065041c214f' : '5ceb163660664d0a52c6'
        return `https://${rootUri}/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code`;
    },

    debounceWait: 1200,
    debounceSearchWait: 500
};

Artcloud.click = {
    _qaApiUrl: 'https://api-click-dev.artcloud.com',
    _prodApiUrl: 'https://api-click.artcld.com',
    _qaHandlerUrl: 'https://click-qa.artcloud.com',
    _prodHandlerUrl: 'https://click.artcld.com',
    requestKey: 'A3AF52F2-C115-4C70-A7A1-624E68BA1734',

    apiUrl: function () {
        return Artcloud.shouldTargetDevApi ? Artcloud.click._qaApiUrl : Artcloud.click._prodApiUrl
    },

    handlerUrl: function (useLocal) {
        if (useLocal == true) {
            return 'https://localhost:49895';
        }
        return Artcloud.shouldTargetDevApi ? Artcloud.click._qaHandlerUrl : Artcloud.click._prodHandlerUrl
    },

    dataSub: {
        artist: '3867cfea-4298-46bc-b324-dad84c00e2a8',
        gallery: 'b5483627-3c47-4a51-af94-a572734442f6'
    },

    router: {
        build: function (route) {
            return `${Artcloud.click.apiUrl()}/click/${route}`;
        },

        configs: {
            get: function () {
                return Artcloud.click.router.build('configs');
            }
        },

        pages: {
            get: function (id) {
                return Artcloud.click.router.build(`pages/${id}`);
            },

            artist: {
                get: function (id) {
                    return Artcloud.click.router.build(`pages/artists/${id}`);
                }
            },

            buy: {
                get: function () {
                    return Artcloud.click.router.build('pages/buy');
                }
            },

            home: {
                get: function () {
                    return Artcloud.click.router.build('pages/home');
                }
            },

            inventory: {
                get: function (id) {
                    return Artcloud.click.router.build(`pages/inventory/${id}`);
                }
            },

            search: {
                get: function () {
                    return Artcloud.click.router.build('pages/search');
                }
            },

            show: {
                get: function (id) {
                    return Artcloud.click.router.build(`pages/shows/${id}`);
                }
            }
        }
    }
};

Artcloud.constants = {
    keys: {
        accounts: {
            value: 'accounts',
            version: 9
        },
        analytics: {
            approvals: {
                value: 'approvals',
                version: 3
            },
            artistPayments: {
                value: 'artist_payments',
                version: 5
            },
            commissions: {
                value: 'commissions',
                version: 7
            },
            consignments: {
                value: 'analytics_consignments',
                version: 8
            },
            layaways: {
                value: 'layaways',
                version: 8
            },
            overview: {
                value: 'analytics_overview',
                version: 1
            },
            payments: {
                value: 'analytics_payments',
                version: 9
            },
            salesByArtist: {
                value: 'sales_by_artist',
                version: 10
            },
            salesOverTime: {
                value: 'sales_over_time',
                version: 13
            },
            taxes: {
                value: 'taxes',
                version: 5
            },
            topContacts: {
                value: 'top_clients',
                version: 7
            },
        },
        artistInvites: {
            value: 'artistInvites',
            version: 0
        },
        artists: {
            value: 'artists',
            version: 9
        },
        audiences: {
            value: 'audiences',
            version: 4
        },
        blogs: {
            value: 'blogs',
            version: 2
        },
        campaigns: {
            value: 'campaigns',
            version: 5
        },
        cities: {
            value: 'cities',
            version: 1
        },
        clients: {
            value: 'clients',
            version: 15
        },
        collateral: {
            value: 'collateral',
            version: 2
        },
        consignments: {
            value: 'consignments',
            version: 5
        },
        dash: {
            value: 'dash',
            version: 0
        },
        editionSets: {
            value: 'editionSets',
            version: 3
        },
        editionTitles: {
            value: 'editionTitles',
            version: 3
        },
        email_templates: {
            value: 'email_templates',
            version: 2
        },
        gallerySales: {
            value: 'gallerySales',
            version: 1
        },
        inventory: {
            value: 'inventory',
            version: 20
        },
        inventory_artist: {
            value: 'inventory_artist',
            version: 7
        },
        inventoryModal_invoice: {
            value: 'invoiceItems',
            version: 6
        },
        inventoryModal_list: {
            value: 'inventoryModal_list',
            version: 5
        },
        inventoryModal_opportunity: {
            value: 'inventoryModal_opportunity',
            version: 5
        },
        inventoryModal_purchaseOrder: {
            value: 'inventoryModal_purchaseOrder',
            version: 2
        },
        invoices: {
            value: 'invoices',
            version: 11
        },
        invoiceStages: {
            value: 'invoiceStages',
            version: 1
        },
        lists: {
            value: 'lists',
            version: 6
        },
        messages: {
            value: 'messages',
            version: 2
        },
        newArrivals: {
            value: 'newArrivals',
            version: 2
        },
        noLogins: {
            value: 'noLogins',
            version: 2
        },
        opportunities: {
            value: 'opportunities',
            version: 7
        },
        promoCodes: {
            value: 'promoCodes',
            version: 1
        },
        purchaseOrders: {
            value: 'purchaseOrders',
            version: 1
        },
        quicklist_items: {
            value: 'quicklist_items',
            version: 3
        },
        quicklists: {
            value: 'quicklists',
            version: 6
        },
        releaseNotes: {
            value: 'releaseNotes',
            version: 2
        },
        representatives: {
            value: 'representatives',
            version: 1
        },
        show_items: {
            value: 'show_items',
            version: 3
        },
        shows: {
            value: 'shows',
            version: 6
        },
        todos: {
            value: 'todos',
            version: 3
        },

        admin: 'isadmin',
        artsyRedirect: 'ac_artsyRedirect',
        constantContactRedirect: 'ac_constantContactRedirect',
        destination: {
            value: 'destination',
            version: 2
        },
        legacyCollateral: 'ac_legacyCollateral',
        mailchimpRedirect: 'ac_mailchimpRedirect',
        session: 'ac_session',
        subscriptionCookie: 'ac_subscription',
        welcomeGate: 'ac_welcome'
    }
};

Artcloud.storage = {
    clear: function () {
        if (typeof Storage !== 'undefined') {
            localStorage.clear();
        }
    },

    get: function (key, def) {
        if (!key || typeof Storage === 'undefined') {
            return;
        }
        const _key = this._keyVersion(key);
        if (!_key) {
            return;
        }
        const _item = localStorage.getItem(_key.value);
        if (_item && _item !== 'null') {
            const obj = JSON.parse(_item);
            if (obj.value && obj.version == _key.version) {
                return obj.value;
            }
        }
        if (def) {
            return def;
        }
    },

    put: function (key, value) {
        if (!key || typeof Storage === 'undefined') {
            return;
        }
        const _key = this._keyVersion(key);
        if (!_key) {
            return;
        }
        let _item = null;
        if (value) {
            _item = { value: value, version: _key.version };
        }
        localStorage.setItem(_key.value, JSON.stringify(_item));
    },

    remove: function (key) {
        if (!key || typeof Storage === 'undefined') {
            return;
        }
        const _key = this._keyVersion(key);
        if (!_key) {
            return;
        }
        localStorage.removeItem(_key.value);
    },

    _keyVersion: function (key) {
        if (!key) {
            return;
        }
        let _key = key;
        let _version = 1;
        if (!_.isString(_key)) {
            _key = key.value;
            _version = key.version;
        }
        return { value: _key, version: _version };
    }
};

Artcloud.auth = {
    logout: function () {
        const attributes = { path: '/', domain: Artcloud.cookieDomain };
        Cookies.remove(Artcloud.constants.keys.admin, attributes);
        Cookies.remove(Artcloud.constants.keys.session, attributes);
        window.location = Artcloud.isQa ? 'https://qa.artcloud.com/login' : 'https://artcloud.com';
    },

    spoof: function (session) {
        const attributes = { path: '/', domain: Artcloud.cookieDomain, secure: true, sameSite: 'lax' };
        Cookies.set(Artcloud.constants.keys.admin, true, attributes);
        Cookies.set(Artcloud.constants.keys.session, session, attributes);
    }
};

Artcloud.data = {
    document: function (method, url, data, inline, done, fail) {
        Artcloud.data[method](url, data, function (data) {
            const baseUrl = window.location.origin;
            const href = `${baseUrl}/doc/${data.FileName}?id=${data.Id}&inline=${inline}`;
            var a = document.createElement('a');
            a.href = href;
            if (inline) {
                a.target = '_blank';
            }
            else if (typeof a.download !== 'undefined') {
                a.download = data.FileName;
            }
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            if (typeof done === 'function') {
                done(data);
            }
        }, fail);
    },

    file: function (method, url, q, data, callback) {
        const isGet = method === 'GET';
        var body = null;

        if (data) {
            var encoded;
            if (isGet) {
                encoded = $.param(data);
            } else {
                encoded = JSON.stringify(data);
            }
            body = encoded;
        }
        if (q) {
            var encoded = $.param(q);
            url += `?${encoded}`;
        }

        var xhr = new XMLHttpRequest();
        xhr.open(method, url, true);
        const attributes = { path: '/', domain: Artcloud.cookieDomain };
        var session = Cookies.get(Artcloud.constants.keys.session, attributes);
        xhr.setRequestHeader('Authorization', 'Bearer ' + session);
        xhr.setRequestHeader('X-API-Key', '0E51A4A4-381F-4934-829F-D8CC1555981F');
        xhr.responseType = 'arraybuffer';
        xhr.onload = function () {
            const status = this.status;
            if (status === 200) {
                var filename = "";
                var disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                }
                var type = xhr.getResponseHeader('Content-Type');

                const ms = typeof window.navigator.msSaveBlob !== 'undefined';

                var blob = (typeof File === 'function' && !ms)
                    ? new File([this.response], filename, { type: type })
                    : new Blob([this.response], { type: type });
                if (ms) {
                    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                    var URL = window.URL || window.webkitURL;
                    var downloadUrl = URL.createObjectURL(blob);

                    if (filename) {
                        // use HTML5 a[download] attribute to specify filename
                        var a = document.createElement("a");
                        // safari doesn't support this yet
                        if (typeof a.download === 'undefined') {
                            //window.location = downloadUrl;
                            window.open(downloadUrl, '_blank');
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                    } else {
                        //window.location = downloadUrl;
                        window.open(downloadUrl, '_blank');
                    }

                    setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
                }
            }
            else if (status === 401) {
                Artcloud.data.handle401();
            }
            if (callback) {
                callback(status);
            }
        };

        if (isGet) {
            xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        } else {
            xhr.setRequestHeader('Content-type', 'application/json');
        }
        xhr.send(body);
    },

    get: function (url, data, done, fail, headers, allowDuplicateRequests) {
        return Artcloud.data._helper('GET', url, data, done, fail, headers, allowDuplicateRequests);
    },

    getWithImageFace: function (url, data, done, fail) {
        return Artcloud.data._withImageFace(Artcloud.data.get, url, data, done, fail);
    },

    _withImageFace: function (verbFunction, url, data, done, fail) {
        const headers = [{ key: 'X-Image-Transform', value: 'g_face' }];
        return verbFunction(url, data, done, fail, headers);
    },

    post: function (url, data, done, fail, headers, allowDuplicateRequests) {
        return Artcloud.data._helper('POST', url, data, done, fail, headers, allowDuplicateRequests);
    },

    postWithImageFace: function (url, data, done, fail) {
        return Artcloud.data._withImageFace(Artcloud.data.post, url, data, done, fail);
    },

    put: function (url, data, done, fail, headers, allowDuplicateRequests) {
        return Artcloud.data._helper('PUT', url, data, done, fail, headers, allowDuplicateRequests);
    },

    del: function (url, data, done, fail, headers) {
        return Artcloud.data._helper('DELETE', url, data, done, fail, headers);
    },

    createErrorResponse: function (message) {
        return { responseJSON: { Message: message } };
    },

    handle401: function () {
        let loginUrl = `https://${Artcloud.isQa ? 'qa.' : ''}artcloud.com/login`;
        let returnUrl = window.location.href;
        if (returnUrl) {
            loginUrl += `?returnUrl=${encodeURIComponent(returnUrl)}`;
        }
        window.location = loginUrl;
        return;
    },

    _requests: {},

    _helper: function (method, uri, data, done, fail, headers, allowDuplicateRequests) {
        var acd = this;

        const isGet = method === 'GET';
        data = isGet
            ? data
            : data
                ? JSON.stringify(data)
                : null;

        var settings = {
            accepts: {
                text: 'application/json'
            },
            data: data,
            dataType: 'json',
            contentType: 'application/json',
            type: method,
            beforeSend: function (request) {
                const attributes = { path: '/', domain: Artcloud.cookieDomain };
                var session = Cookies.get(Artcloud.constants.keys.session, attributes);
                request.setRequestHeader('Authorization', 'Bearer ' + session);
                request.setRequestHeader('X-API-Key', '0E51A4A4-381F-4934-829F-D8CC1555981F');

                if (headers) {
                    for (var i = 0; i < headers.length; i++) {
                        var header = headers[i];
                        request.setRequestHeader(header.key, header.value);
                    }
                }
            },
            url: uri
        };

        const requests = acd._requests;
        var key = `${method}_${uri}`.toLowerCase();
        if (isGet && data) {
            key = `${key}?${acd._serialize(data)}`;
        }
        key = key.toLowerCase();

        if (requests[key] && allowDuplicateRequests !== true) {
            requests[key].abort();
        }

        var jqXHR = $.ajax(settings)
            .always(function () {
                delete requests[key];
            })
            .done(function (data, textStatus, jqXHR) {
                if (typeof done === 'function') {
                    done(data, textStatus, jqXHR);
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                if (textStatus === 'abort') {
                    return;
                }

                if ((jqXHR.status === 200 || jqXHR.status === 201 || jqXHR.status === 202) && textStatus === 'parsererror') {
                    if (typeof done === 'function') {
                        done(jqXHR.responseText, textStatus, jqXHR);
                    }
                }
                else if (jqXHR.status === 401) {
                    Artcloud.data.handle401();
                }
                else {
                    if (typeof fail === 'function') {
                        fail(jqXHR, textStatus, errorThrown);
                    }
                    else {
                        acd._fail(jqXHR, textStatus, errorThrown);
                    }
                }
            });

        requests[key] = jqXHR;
        return jqXHR;
    },

    _serialize: function (obj) {
        var formatted = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                formatted.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
            }
        }
        return formatted.join('&');
    },

    _serializeArray: function (array, q, paramName) {
        if (!array) {
            return;
        }
        var obj;
        for (var i = 0; i < array.length; i++) {
            obj = array[i];
            if (!obj) {
                obj = '';
            }
            var key = `${paramName}[${i}]`;
            if (typeof obj === 'object') {
                for (var name in obj) {
                    q[`${key}.${name}`] = obj[name];
                }
            } else {
                q[key] = obj;
            }
        }
    },

    _fail: function (jqXHR, textStatus, errorThrown) {
        if (textStatus === 'abort') {
            return;
        }

        if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.Message) {
            alert(jqXHR.responseJSON.Message);
        }
        else {
            if (jqXHR) {
                console.log(`jqXHR.state(): ${jqXHR.state()}`);
                console.log(`jqXHR.status: ${jqXHR.status}`);
            }
            console.log(`textStatus: ${textStatus}`);
            console.log(`errorThrown: ${errorThrown}`);
            alert('There was an error with your request. Please wait a moment and try again.');
        }
    },

    fetch: function (url, method, onSuccess, onFail, headers) {
        let ok;
        return fetch(url, {
            method: method,
            headers: headers
        })
            .then(function (response) {
                ok = response.ok;
                return response.json();
            })
            .then(function (data) {
                if (ok) {
                    return onSuccess(data);
                }
                else {
                    return onFail(data);
                }
            });
    },

    downloadDocument: function (doc, targetNewWindow) {
        if (!doc) {
            return;
        }
        var a = document.createElement('a');
        a.download = doc.Filename;
        a.href = doc.Url;
        if (targetNewWindow == true) {
            a.target = '_blank';
        }
        document.body.appendChild(a);
        
        setTimeout(() => {
            a.click();
            document.body.removeChild(a);
        }, 500);
    }
};

Artcloud.router = {
    _base: 'https://api.artcloud.com/api/',
    get base() {
        return Artcloud.shouldTargetDevApi ? 'https://api-dev.artcloud.com/api/' : this._base;
        // return Artcloud.shouldTargetDevApi ? 'http://localhost:51162/api/' : this._base;
    },

    build: function (suffix) {
        return (Artcloud.router.base + suffix);
    },

    newRouteReplacement: function (location, newId) {
        if (location) {
            let currentPath = location.pathname;
            return currentPath.replace('/new', `/${newId}`);
        } else {
            return null;
        }
    },

    pathWithQuery: function (path, query) {
        let queryString = '?';
        let _query = query || {};
        for (let id in _query) {
            const q = _query[id];
            if (q != undefined && q != null) {
                queryString += `${id}=${q}&`;
            }
        }
        if (queryString.length > 1) {
            queryString = queryString.substring(0, queryString.length - 1);
            return path + queryString;
        }
        return path;
    },

    addresses: {
        post: function () {
            return Artcloud.router.build('addresses');
        }
    },

    admin: {
        accounts: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`admin/accounts/${id}`);
                } else {
                    return Artcloud.router.build('admin/accounts');
                }
            },
            del: function (id) {
                return Artcloud.router.build(`admin/accounts/${id}`);
            },
            put: function (id) {
                return Artcloud.router.build(`admin/accounts/${id}`);
            },

            actions: {
                claimBrandPackage: {
                    post: function (userId) {
                        return Artcloud.router.build(`admin/accounts/${userId}/actions/1`);
                    }
                },
                downloadConfig: {
                    post: function (userId) {
                        return Artcloud.router.build(`admin/accounts/${userId}/actions/0`);
                    }
                }
            },

            exports: {
                csv: {
                    get: function () {
                        return Artcloud.router.build('admin/accounts/csv');
                    }
                }
            },

            spoof: {
                put: function () {
                    return Artcloud.router.build('admin/accounts/spoof');
                }
            },

            trials: {
                put: function (id) {
                    return Artcloud.router.build(`admin/accounts/${id}/trials`);
                }
            }
        },

        emails: {
            post: function () {
                return Artcloud.router.build('admin/emails');
            }
        },

        kpis: {
            get: function () {
                return Artcloud.router.build('admin/kpis');
            },

            exports: {
                stripe: {
                    csv: {
                        get: function () {
                            return Artcloud.router.build('admin/kpis/exports/stripe/csv');
                        }
                    }
                },
                website: {
                    csv: {
                        get: function () {
                            return Artcloud.router.build('admin/kpis/exports/website/csv');
                        }
                    }
                }
            }
        },

        merges: {
            contacts: {
                post: function () {
                    return Artcloud.router.build('admin/merges/contacts');
                }
            }
        },

        resources: {
            get: function () {
                return Artcloud.router.build('admin/resources');
            },

            exports: {
                csv: {
                    get: function () {
                        return Artcloud.router.build('admin/resources/exports/csv');
                    }
                }
            },

            graphs: {
                get: function () {
                    return Artcloud.router.build('admin/resources/graphs');
                }
            },

            totals: {
                get: function () {
                    return Artcloud.router.build('admin/resources/totals');
                }
            }
        },

        risks: {
            logins: {
                list: function () {
                    return Artcloud.router.build('admins/risks/logins');
                }
            }
        }
    },

    analytics: {
        bottomLine: {
            get: function () {
                return Artcloud.router.build('analytics/bottomline');
            }
        },
        followers: {
            get: function () {
                return Artcloud.router.build('analytics/followers');
            }
        },
        funnel: {
            get: () => Artcloud.router.build('analytics/funnel'),

            averages: {
                get: () => Artcloud.router.build('analytics/funnel/averages/etr')
            },

            awareness: {
                get: () => Artcloud.router.build('analytics/funnel/awareness')
            },

            channels: {
                get: () => Artcloud.router.build('analytics/funnel/channels')
            },

            inquiries: {
                get: () => Artcloud.router.build('analytics/funnel/inquiries')
            }
        },
        impressions: {
            get: function () {
                return Artcloud.router.build('analytics/impressions');
            }
        },
        location: {
            get: function () {
                return Artcloud.router.build('analytics/location');
            }
        },
        origins: {
            get: function () {
                return Artcloud.router.build('analytics/origins');
            }
        },
        topArtists: {
            get: function () {
                return Artcloud.router.build('analytics/topartists');
            }
        },
        tracking: {
            get: () => Artcloud.router.build('analytics/tracking')
        }
    },

    arrivals: {
        recipients: {
            get: function (id) {
                return Artcloud.router.build(`arrivals/${id}/recipients`);
            }
        }
    },

    artistInvites: {
        get: function () {
            return Artcloud.router.build('artistInvites');
        }
    },

    artists: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`v2/artists/${id}`);
            }
            else {
                return Artcloud.router.build('v3/artists');
            }
        },

        post: function (id) {
            return Artcloud.router.build('v2/artists');
        },

        put: function (id) {
            return Artcloud.router.build(`v2/artists/${id}`);
        },

        del: function (id) {
            return Artcloud.router.build(`v2/artists/${id}`);
        },

        activities: {
            get: function (id) {
                return Artcloud.router.build(`artists/${id}/activities`);
            }
        },

        all: {
            get: function () {
                return Artcloud.router.build('v3/artists/all');
            }
        },

        documents: {
            get: function (id) {
                return Artcloud.router.build(`artists/${id}/documents`);
            },
            post: function (id) {
                return Artcloud.router.build(`artists/${id}/documents`);
            },
            del: function (id, documentId) {
                return Artcloud.router.build(`artists/${id}/documents/${documentId}`);
            },

            signedUrls: {
                post: function (id, documentId) {
                    return Artcloud.router.build(`artists/${id}/documents/${documentId}/signedUrls`);
                }
            }
        },

        emails: {
            get: function (id) {
                return Artcloud.router.build(`artists/${id}/emails`);
            },
            post: function (id) {
                return Artcloud.router.build(`artists/${id}/emails`);
            },
            put: function (id, emailId) {
                return Artcloud.router.build(`artists/${id}/emails/${emailId}`);
            },
            del: function (id, emailId) {
                return Artcloud.router.build(`artists/${id}/emails/${emailId}`);
            }
        },

        exports: {
            csv: {
                get: function () {
                    return Artcloud.router.build('artists/exports/csv');
                }
            }
        },

        followers: {
            post: function (id) {
                return Artcloud.router.build(`artists/${id}/followers`);
            },

            exports: {
                csv: {
                    get: function (id) {
                        return Artcloud.router.build(`artists/${id}/followers/exports/csv`);
                    }
                }
            }
        },

        inventory: {
            get: function (id) {
                return Artcloud.router.build(`artists/${id}/inventory`);
            }
        },

        invite: {
            post: function (id) {
                return Artcloud.router.build(`artists/${id}/invites`);
            }
        },

        images: {
            profile: {
                get: function (id) {
                    return Artcloud.router.build(`artists/${id}/images/profile`);
                },
                post: function (id) {
                    return Artcloud.router.build(`artists/${id}/images/profile`);
                },
                del: function (id, imageId) {
                    return Artcloud.router.build(`artists/${id}/images/profile/${imageId}`);
                }
            },

            featured: {
                get: function (id) {
                    return Artcloud.router.build(`artists/${id}/images/featured`);
                },
                post: function (id) {
                    return Artcloud.router.build(`artists/${id}/images/featured`);
                },
                del: function (id, imageId) {
                    return Artcloud.router.build(`artists/${id}/images/featured/${imageId}`);
                }
            }
        },

        lists: {
            get: function (id) {
                return Artcloud.router.build(`artists/${id}/lists`);
            }
        },

        qrCodes: {
            get: function (artistId) {
                return Artcloud.router.build(`artists/${artistId}/qrCodes`);
            },
        },

        socials: {
            get: function (id) {
                return Artcloud.router.build(`artists/${id}/socials`);
            },
            post: function (id) {
                return Artcloud.router.build(`artists/${id}/socials`);
            },
            put: function (id, socialId) {
                return Artcloud.router.build(`artists/${id}/socials/${socialId}`);
            },
            del: function (id, socialId) {
                return Artcloud.router.build(`artists/${id}/socials/${socialId}`);
            }
        },
    },

    artsy: {
        artists: {
            get: function() {
                return Artcloud.router.build(`artsy/artists`);
            },

            post: function(artistId) {
                return Artcloud.router.build(`artsy/artists/${artistId}`);
            },

            del: function(artistId) {
                return Artcloud.router.build(`artsy/artists/${artistId}`);
            },

            association: {
                post: function(artistId, artsyId) {
                    return Artcloud.router.build(`artsy/artists/${artistId}/${artsyId}`);
                }
            },
            
            matches: {
                get: function () {
                    return Artcloud.router.build(`artsy/artists/matches`);
                }
            }
        },

        inventory: {
            get: function(id) {
                if (id) {
                    return Artcloud.router.build(`artsy/inventory/${id}`);
                }
                return Artcloud.router.build(`artsy/inventory`);
            },

            post: function(inventoryId) {
                return Artcloud.router.build(`artsy/inventory/${inventoryId}`);
            },

            put: function(inventoryId) {
                return Artcloud.router.build(`artsy/inventory/${inventoryId}`);
            },

            del: function(inventoryId) {
                return Artcloud.router.build(`artsy/inventory/${inventoryId}`);
            },

            association: {
                post: function(inventoryId, artsyId) {
                    return Artcloud.router.build(`artsy/inventory/${inventoryId}/${artsyId}`);
                }
            },
            
            matches: {
                get: function () {
                    return Artcloud.router.build(`artsy/inventory/matches`);
                }
            },
            
            totals: {
                get: function () {
                    return Artcloud.router.build(`artsy/inventory/totals`);
                }
            }
        },

        locations: {
            get: function() {
                return Artcloud.router.build(`artsy/locations`);
            },

            put: function() {
                return Artcloud.router.build(`artsy/locations`);
            }
        },

        partners: {
            get: function() {
                return Artcloud.router.build(`artsy/partners`);
            },

            put: function() {
                return Artcloud.router.build(`artsy/partners`);
            }
        }
    },

    auth: {
        put: function () {
            return Artcloud.router.build('auth/login');
        },
        del: function () {
            return Artcloud.router.build('auth');
        }
    },

    batches: {
        get: function (type, id) {
            if (id) {
                return Artcloud.router.build(`batches/${type}/${id}`);
            } else {
                return Artcloud.router.build(`batches`);
            }
        },

        artists: {
            post: function () {
                return Artcloud.router.build('batches/artists');
            }
        },
        clients: {
            post: function () {
                return Artcloud.router.build('batches/clients');
            }
        },
        editionTitles: {
            post: function () {
                return Artcloud.router.build('batches/editionTitles');
            }
        },
        items: {
            post: function () {
                return Artcloud.router.build('batches/items');
            },

            holds: {
                post: function () {
                    return Artcloud.router.build('batches/items/holds');
                }
            },

            unconsign: {
                post: function () {
                    return Artcloud.router.build('batches/items/unconsign');
                }
            }
        },
        opportunities: {
            post: function () {
                return Artcloud.router.build('batches/opportunities');
            }
        }
    },

    blockedEmails: {
        get: function () {
            return Artcloud.router.build(`blockedEmails`);
        },
        post: function () {
            return Artcloud.router.build(`blockedEmails`);
        },
        del: function (id) {
            return Artcloud.router.build(`blockedEmails/${id}`);
        },
    },

    billing: {
        permissions: {
            get: function (type) {
                return Artcloud.router.build(`billing/permissions/${type}`);
            }
        },

        usage: {
            get: function (permission) {
                if (permission) {
                    return Artcloud.router.build(`billing/usage/${permission}`);
                } else {
                    return Artcloud.router.build(`billing/usage`);
                }
            }
        }
    },

    blogs: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`blogs/${id}`);
            } else {
                return Artcloud.router.build(`blogs`);
            }
        },
        post: function () {
            return Artcloud.router.build(`blogs`);
        },
        put: function (id) {
            return Artcloud.router.build(`blogs/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`blogs/${id}`);
        },

        artists: {
            get: function (id) {
                return Artcloud.router.build(`blogs/${id}/artists`);
            },
            put: function (id) {
                return Artcloud.router.build(`blogs/${id}/artists`);
            },
            del: function (id, artistId) {
                return Artcloud.router.build(`blogs/${id}/artists/${artistId}`);
            }
        },

        configs: {
            get: function (id) {
                return Artcloud.router.build(`blogs/${id}/configs`);
            },
            put: function (id) {
                return Artcloud.router.build(`blogs/${id}/configs`);
            }
        },

        duplicates: {
            post: function (id) {
                return Artcloud.router.build(`blogs/${id}/duplicates`);
            }
        },

        images: {
            post: function () {
                return Artcloud.router.build(`blogs/images`);
            },

            featured: {
                post: function (id) {
                    return Artcloud.router.build(`blogs/${id}/images/featured`);
                }
            }
        },

        inventory: {
            get: function (id) {
                return Artcloud.router.build(`blogs/${id}/inventory`);
            },
            put: function (id) {
                return Artcloud.router.build(`blogs/${id}/inventory`);
            },
            del: function (id, inventoryId) {
                return Artcloud.router.build(`blogs/${id}/inventory/${inventoryId}`);
            }
        },

        quicklists: {
            get: function (id) {
                return Artcloud.router.build(`blogs/${id}/quicklists`);
            },
            put: function (id) {
                return Artcloud.router.build(`blogs/${id}/quicklists`);
            },
            del: function (id, quicklistId) {
                return Artcloud.router.build(`blogs/${id}/quicklists/${quicklistId}`);
            }
        }
    },

    brandPackages: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`brandPackages/${id}`);
            } else {
                return Artcloud.router.build('brandPackages');
            }
        },
        post: function () {
            return Artcloud.router.build('brandPackages');
        },
        del: function (id) {
            return Artcloud.router.build(`brandPackages/${id}`);
        },
        put: function (id) {
            return Artcloud.router.build(`brandPackages/${id}`);
        },

        claims: {
            post: function (id) {
                return Artcloud.router.build(`brandPackages/${id}/claims`);
            }
        },

        collaterals: {
            get: function (id) {
                return Artcloud.router.build(`brandPackages/${id}/collaterals`);
            }
        },

        configs: {
            get: function (id) {
                return Artcloud.router.build(`brandPackages/${id}/configs`);
            },
            post: function (id) {
                return Artcloud.router.build(`v2/brandPackages/${id}/configs`);
            }
        },

        images: {
            post: function (id) {
                return Artcloud.router.build(`brandPackages/${id}/images`);
            }
        }
    },

    campaigns: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`campaigns/${id}`);
            } else {
                return Artcloud.router.build('campaigns');
            }
        },
        post: function () {
            return Artcloud.router.build('campaigns');
        },
        put: function (id) {
            return Artcloud.router.build(`campaigns/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`campaigns/${id}`);
        },

        blocks: {
            inventory: {
                post: function () {
                    return Artcloud.router.build('campaigns/blocks/inventory');
                }
            }
        },

        domains: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`campaigns/domains/${id}`);
                } else {
                    return Artcloud.router.build('campaigns/domains');
                }
            },
            post: function () {
                return Artcloud.router.build('campaigns/domains');
            },

            validations: {
                post: function (id) {
                    return Artcloud.router.build(`campaigns/domains/${id}/validations`);
                }
            }
        },

        inventory: {
            get: function () {
                return Artcloud.router.build(`campaigns/inventory`);
            }
        },

        clicks: {
            get: function (id) {
                return Artcloud.router.build(`campaigns/${id}/clicks`);
            },

            details: {
                get: function (id) {
                    return Artcloud.router.build(`campaigns/${id}/clicks/details`);
                }
            }
        },

        configs: {
            get: function (id) {
                return Artcloud.router.build(`campaigns/${id}/configs`);
            },
            put: function (id) {
                return Artcloud.router.build(`campaigns/${id}/configs`);
            }
        },

        deliveries: {
            post: function (id) {
                return Artcloud.router.build(`campaigns/v2/${id}/deliveries`);
            }
        },

        duplicates: {
            post: function (id) {
                return Artcloud.router.build(`campaigns/${id}/duplicates`);
            }
        },

        events: {
            get: function (id, type, emailId) {
                let route = Artcloud.router.build(`campaigns/${id}/events/${type}`);
                if (emailId) {
                    route += `/${emailId}`;
                }
                return route;
            },

            exports: {
                csv: {
                    get: function (id, type) {
                        if (type) {
                            return Artcloud.router.build(`campaigns/${id}/events/${type}/exports/csv`);
                        }
                        return Artcloud.router.build(`campaigns/${id}/events/exports/csv`);
                    }
                }
            },

            totals: {
                get: function (id) {
                    return Artcloud.router.build(`campaigns/${id}/events/totals`);
                }
            }
        },

        images: {
            post: function () {
                return Artcloud.router.build('campaigns/images');
            }
        },

        previews: {
            get: function (id) {
                return Artcloud.router.build(`campaigns/${id}/previews`);
            },
            post: function (id) {
                return Artcloud.router.build(`campaigns/v2/${id}/previews`);
            }
        },

        settings: {
            get: function () {
                return Artcloud.router.build('campaigns/settings');
            },

            logos: {
                put: function () {
                    return Artcloud.router.build('campaigns/settings/logos');
                }
            }
        }
    },

    cities: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`cities/${id}`);
            } else {
                return Artcloud.router.build('cities');
            }
        },
        post: function () {
            return Artcloud.router.build('cities');
        },
        del: function (id) {
            return Artcloud.router.build(`cities/${id}`);
        },
        put: function (id) {
            return Artcloud.router.build(`cities/${id}`);
        },

        images: {
            featured: {
                post: function (id) {
                    return Artcloud.router.build(`cities/${id}/images/featured`);
                }
            }
        }
    },

    clients: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`clients/${id}`);
            }
            else {
                return Artcloud.router.build('clients');
            }
        },
        post: function () {
            return Artcloud.router.build('clients');
        },
        put: function (id) {
            return Artcloud.router.build(`clients/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`clients/${id}`);
        },

        activities: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/activities`);
            }
        },

        addresses: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/addresses`);
            },
            post: function (id) {
                return Artcloud.router.build(`clients/${id}/addresses`);
            },
            put: function (id, addressId) {
                return Artcloud.router.build(`clients/${id}/addresses/${addressId}`);
            },
            del: function (id, addressId) {
                return Artcloud.router.build(`clients/${id}/addresses/${addressId}`);
            }
        },

        all: {
            get: function () {
                return Artcloud.router.build('clients/all');
            }
        },

        audiences: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`clients/audiences/${id}`);
                } else {
                    return Artcloud.router.build('clients/audiences');
                }
            },
            post: function () {
                return Artcloud.router.build('clients/audiences');
            },
            put: function (id) {
                return Artcloud.router.build(`clients/audiences/${id}`);
            },
            del: function (id) {
                return Artcloud.router.build(`clients/audiences/${id}`);
            },

            members: {
                get: function (id) {
                    return Artcloud.router.build(`clients/audiences/${id}/members`);
                },

                exports: {
                    csv: {
                        get: function (id) {
                            return Artcloud.router.build(`clients/audiences/${id}/members/exports/csv`);
                        }
                    },
                    labels: {
                        get: function (id) {
                            return Artcloud.router.build(`clients/audiences/${id}/members/exports/labels`);
                        }
                    }
                },

                labels: {
                    get: function (id) {
                        return Artcloud.router.build(`clients/audiences/${id}/members/labels`);
                    }
                },

                totals: {
                    get: function (id) {
                        return Artcloud.router.build(`clients/audiences/${id}/members/totals`);
                    }
                }
            }
        },

        cards: {
            get: function (id) {
                return Artcloud.router.build(`v2/clients/${id}/cards`);
            },
            post: function (id) {
                return Artcloud.router.build(`v2/clients/${id}/cards`);
            },
            del: function (id, cardId) {
                return Artcloud.router.build(`v2/clients/${id}/cards/${cardId}`);
            }
        },

        credits: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/credits`);
            },
            post: function (id) {
                return Artcloud.router.build(`clients/${id}/credits`);
            },
            del: function (id, creditId) {
                return Artcloud.router.build(`clients/${id}/credits/${creditId}`);
            }
        },

        documents: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/documents`);
            },
            post: function (id) {
                return Artcloud.router.build(`clients/${id}/documents`);
            },
            del: function (id, documentId) {
                return Artcloud.router.build(`clients/${id}/documents/${documentId}`);
            },

            signedUrls: {
                post: function (id, documentId) {
                    return Artcloud.router.build(`clients/${id}/documents/${documentId}/signedUrls`);
                }
            }
        },

        emails: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/emails`);
            },
            post: function (id) {
                return Artcloud.router.build(`clients/${id}/emails`);
            },
            put: function (id, emailId) {
                return Artcloud.router.build(`clients/${id}/emails/${emailId}`);
            },
            del: function (id, emailId) {
                return Artcloud.router.build(`clients/${id}/emails/${emailId}`);
            }
        },

        exports: {
            csv: {
                get: function () {
                    return Artcloud.router.build(`clients/exports/csv`);
                }
            },
            labels: {
                get: function () {
                    return Artcloud.router.build(`clients/exports/labels`);
                }
            },
            mailchimp: {
                get: function () {
                    return Artcloud.router.build(`clients/exports/mailchimp`);
                }
            }
        },

        images: {
            profile: {
                get: function (id) {
                    return Artcloud.router.build(`v2/clients/${id}/images/profile`);
                },
                post: function (id) {
                    return Artcloud.router.build(`v2/clients/${id}/images/profile`);
                },
                del: function (id, imageId) {
                    return Artcloud.router.build(`v2/clients/${id}/images/profile/${imageId}`);
                }
            }
        },

        invoiceItems: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/invoiceItems`);
            },

            all: {
                get: function (id) {
                    return Artcloud.router.build(`clients/${id}/invoiceItems/all`);
                }
            }
        },

        labels: {
            get: function () {
                return Artcloud.router.build(`clients/labels`);
            }
        },

        leads: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/leads`);
            },
            post: function (id) {
                return Artcloud.router.build(`clients/${id}/leads`);
            },
            put: function (id, itemId) {
                return Artcloud.router.build(`clients/${id}/leads/${itemId}`);
            },
            del: function (id, itemId) {
                return Artcloud.router.build(`clients/${id}/leads/${itemId}`);
            },

            artists: {
                get: function (id) {
                    return Artcloud.router.build(`clients/${id}/leads/artists`);
                },
                post: function (id) {
                    return Artcloud.router.build(`clients/${id}/leads/artists`);
                },
                del: function (id, artistId) {
                    return Artcloud.router.build(`clients/${id}/leads/artists/${artistId}`);
                }
            }
        },

        notes: {
            post: function (id) {
                return Artcloud.router.build(`clients/${id}/activities`);
            },
            put: function (id, activityId) {
                return Artcloud.router.build(`clients/${id}/activities/${activityId}`);
            },
            del: function (id, activityId) {
                return Artcloud.router.build(`clients/${id}/activities/${activityId}`);
            }
        },

        opportunities: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/opportunities`);
            }
        },

        potentialPurchases: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/potentialPurchases`);
            }
        },

        socials: {
            get: function (id) {
                return Artcloud.router.build(`clients/${id}/socials`);
            },
            post: function (id) {
                return Artcloud.router.build(`clients/${id}/socials`);
            },
            put: function (id, socialId) {
                return Artcloud.router.build(`clients/${id}/socials/${socialId}`);
            },
            del: function (id, socialId) {
                return Artcloud.router.build(`clients/${id}/socials/${socialId}`);
            }
        },

        todos: {
            get: function () {
                return Artcloud.router.build('todos');
            }
        }
    },

    collateral: {
        get: function (id) {
            if (id || id === 0) {
                return Artcloud.router.build(`collateral/${id}`);
            }
            else {
                return Artcloud.router.build('collateral');
            }
        },
        post: function () {
            return Artcloud.router.build('collateral');
        },
        put: function (id) {
            return Artcloud.router.build(`collateral/${id}`);
        },
        quick: {
            post: function () {
                return Artcloud.router.build('collateral/quick');
            }
        },
        layouts: {
            get: function () {
                return Artcloud.router.build('collateral/layouts');
            }
        },
        styleguides: {
            get: function () {
                return Artcloud.router.build('collateral/styleguides');
            },
            post: function () {
                return Artcloud.router.build('collateral/styleguides');
            },
            put: function (id) {
                return Artcloud.router.build(`collateral/styleguides/${id}`);
            },

            collateral: {
                get: function () {
                    return Artcloud.router.build('collateral/styleguides/0');
                },
                put: function () {
                    return Artcloud.router.build('collateral/styleguides/0');
                },

                images: {
                    logo: {
                        get: function () {
                            return Artcloud.router.build('collateral/styleguides/0/images/logo');
                        },
                        put: function () {
                            return Artcloud.router.build('collateral/styleguides/0/images/logo');
                        },
                        del: function () {
                            return Artcloud.router.build('collateral/styleguides/0/images/logo');
                        },
                    }
                }
            },

            website: {
                get: function () {
                    return Artcloud.router.build('collateral/styleguides/1');
                },
                put: function () {
                    return Artcloud.router.build('collateral/styleguides/1');
                }
            }
        },
        templates: {
            get: function () {
                return Artcloud.router.build('collateral/templates');
            },
        },
        walltags: {
            post: function () {
                return Artcloud.router.build('v2/collateral/walltags');
            },
            preview: {
                post: function () {
                    return Artcloud.router.build('v2/collateral/walltags/preview');
                },
            }
        }
    },

    collaterals: {
        configs: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`collaterals/configs/${id}`);
                } else {
                    return Artcloud.router.build('collaterals/configs');
                }
            },
            post: function () {
                return Artcloud.router.build('collaterals/configs');
            },
            put: function (id) {
                return Artcloud.router.build(`collaterals/configs/${id}`);
            },
            del: function (id) {
                return Artcloud.router.build(`collaterals/configs/${id}`);
            }
        },
        bios: {
            post: function () {
                return Artcloud.router.build('v2/collaterals/bios');
            }
        },
        certificates: {
            post: function () {
                return Artcloud.router.build('v2/collaterals/certificates');
            }
        },
        consignments: {
            post: function () {
                return Artcloud.router.build('v2/collaterals/consignments');
            }
        },
        data: {
            bios: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/bios`);
                }
            },
            certificates: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/certificates`);
                }
            },
            consignments: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/consignments`);
                }
            },
            invoices: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/invoices`);
                }
            },
            mosaics: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/mosaics`);
                }
            },
            offers: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/offers`);
                }
            },
            pricelists: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/pricelists`);
                }
            },
            purchaseOrders: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/purchaseOrders`);
                }
            },
            shared: {
                get: function () {
                    return Artcloud.router.build(`collaterals/data/shared`);
                }
            },
            tearsheets: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/tearsheets`);
                }
            },
            walltags: {
                post: function () {
                    return Artcloud.router.build(`collaterals/data/walltags`);
                }
            }
        },
        invoices: {
            post: function () {
                return Artcloud.router.build('v2/collaterals/invoices');
            }
        },
        mosaics: {
            post: function () {
                return Artcloud.router.build('v2/collaterals/mosaics');
            }
        },
        offers: {
            post: function () {
                return Artcloud.router.build('v2/collaterals/offers');
            }
        },
        pricelists: {
            post: function () {
                return Artcloud.router.build('v2/collaterals/pricelists');
            }
        },
        purchaseOrders: {
            post: function () {
                return Artcloud.router.build(`collaterals/purchaseOrders`);
            }
        },
        tearsheets: {
            post: function () {
                return Artcloud.router.build('v2/collaterals/tearsheets');
            }
        }
    },

    collateralTemplatesV2: {
        get: function () {
            return Artcloud.router.build('v2/collateralTemplates');
        },
        post: function () {
            return Artcloud.router.build('v2/collateralTemplates');
        },
        put: function (id) {
            return Artcloud.router.build(`v2/collateralTemplates/${id}`);
        },

        images: {
            get: function (id) {
                return Artcloud.router.build(`v2/collateralTemplates/${id}/images`);
            },
            post: function (id) {
                return Artcloud.router.build(`v2/collateralTemplates/${id}/images`);
            }
        }
    },

    collateralV3: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`v3/collaterals/${id}`);
            } else {
                return Artcloud.router.build('v3/collaterals');
            }
        },
        post: function () {
            return Artcloud.router.build('v3/collaterals');
        },
        put: function (id) {
            if (id) {
                return Artcloud.router.build(`v3/collaterals/${id}`);
            } else {
                return Artcloud.router.build('v3/collaterals');
            }
        },
        del: function (id) {
            return Artcloud.router.build(`v3/collaterals/${id}`);
        },

        actions: {
            post: function (id) {
                return Artcloud.router.build(`v3/collaterals/${id}/actions`);
            }
        },

        configs: {
            get: function (id) {
                return Artcloud.router.build(`v3/collaterals/${id}/configs`);
            },
            put: function (id) {
                return Artcloud.router.build(`v3/collaterals/${id}/configs`);
            }
        },

        fonts: {
            get: function () {
                return Artcloud.router.build(`v3/collaterals/fonts`);
            },
            post: function () {
                return Artcloud.router.build(`v3/collaterals/fonts`);
            }
        },

        kit: {
            get: function () {
                return Artcloud.router.build(`v3/collaterals/configs/kit`);
            },
            put: function () {
                return Artcloud.router.build(`v3/collaterals/configs/kit`);
            }
        }
    },

    compositions: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`compositions/${id}`);
            } else {
                return Artcloud.router.build('compositions');
            }
        },
        post: function () {
            return Artcloud.router.build('compositions');
        },
        put: function (id) {
            return Artcloud.router.build(`compositions/${id}`);
        },

        configs: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`compositions/${id}/configs`);
                } else {
                    return Artcloud.router.build('compositions/configs');
                }
            },
            put: function (id) {
                return Artcloud.router.build(`compositions/${id}/configs`);
            }
        },
        images: {
            get: function (id) {
                return Artcloud.router.build(`compositions/${id}/images`);
            },
            post: function (id) {
                return Artcloud.router.build(`compositions/${id}/images`);
            },
            del: function (id, imageId) {
                return Artcloud.router.build(`compositions/${id}/images/${imageId}`);
            }
        }
    },

    consignments: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`consignments/${id}`);
            } else {
                return Artcloud.router.build('consignments');
            }
        },
        post: function () {
            return Artcloud.router.build('consignments');
        },
        put: function (id) {
            return Artcloud.router.build(`consignments/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`consignments/${id}`);
        },

        accept: {
            post: function (id) {
                return Artcloud.router.build(`consignments/${id}/accept`);
            }
        },
        decline: {
            post: function (id) {
                return Artcloud.router.build(`consignments/${id}/decline`);
            }
        },
        items: {
            get: function (id) {
                return Artcloud.router.build(`consignments/${id}/items`);
            },
            post: function (id) {
                return Artcloud.router.build(`consignments/${id}/items`);
            },

            batches: {
                post: function (id) {
                    return Artcloud.router.build(`consignments/${id}/items/batches`);
                }
            }
        },
        send: {
            post: function (id) {
                return Artcloud.router.build(`consignments/${id}/send`);
            }
        },
    },

    consignmentSales: {
        get: function () {
            return Artcloud.router.build('consignmentSales');
        },
    },

    copilot: {
        suggestions: {
            get: function () {
                return Artcloud.router.build('copilot/suggestions');
            },
            del: function (type, id) {
                return Artcloud.router.build(`copilot/suggestions/${type}/${id}`);
            }
        }
    },

    dash: {
        search: {
            get: function () {
                return Artcloud.router.build('dash/searches');
            }
        },
        todos: {
            get: function () {
                return Artcloud.router.build('todos');
            }
        }
    },

    domains: {
        get: function () {
            return Artcloud.router.build(`domains`);
        },
        post: function () {
            return Artcloud.router.build(`domains`);
        }
    },

    editionSets: {
        get: function () {
            return Artcloud.router.build('editionSets');
        },

        duplications: {
            post: function (id) {
                return Artcloud.router.build(`editionSets/${id}/duplications`);
            }
        },

        editions: {
            put: function (id) {
                return Artcloud.router.build(`editionSets/${id}/editions`);
            }
        }
    },

    editionTitles: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`editionTitles/${id}`);
            }
            else {
                return Artcloud.router.build('editionTitles');
            }
        },
        post: function () {
            return Artcloud.router.build('editionTitles');
        },
        put: function (id) {
            return Artcloud.router.build(`editionTitles/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`editionTitles/${id}`);
        },

        images: {
            put: function (id) {
                return Artcloud.router.build(`editionTitles/${id}/images`);
            }
        },

        inventory: {
            put: function (id, inventoryId) {
                return Artcloud.router.build(`editionTitles/${id}/inventory${inventoryId ? `/${inventoryId}` : ''}`);
            },
            del: function (id, inventoryId) {
                return Artcloud.router.build(`editionTitles/${id}/inventory/${inventoryId}`);
            },
        }
    },

    emailTemplates: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`emailTemplates/${id}`);
            }
            else {
                return Artcloud.router.build('emailTemplates');
            }
        },
        post: function () {
            return Artcloud.router.build('emailTemplates');
        },
        put: function (id) {
            return Artcloud.router.build(`emailTemplates/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`emailTemplates/${id}`);
        },

        contents: {
            get: function (id) {
                return Artcloud.router.build(`emailTemplates/${id}/contents`);
            },
        },

        duplicates: {
            post: function (id) {
                return Artcloud.router.build(`emailTemplates/${id}/duplicates`);
            }
        }
    },

    exports: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`exports/${id}`);
            }
            return Artcloud.router.build('exports');
        },

        documents: {
            get: function (id, documentId) {
                return Artcloud.router.build(`exports/${id}/documents/${documentId}`);
            }
        }
    },

    images: {
        post: function () {
            return Artcloud.router.build(`images`);
        }
    },

    imports: {
        get: function () {
            return Artcloud.router.build('imports');
        },
        post: function () {
            return Artcloud.router.build('imports');
        },

        arternal: {
            post: function () {
                return Artcloud.router.build(`imports/arternal`);
            }
        },

        artlogic: {
            post: function () {
                return Artcloud.router.build(`imports/artlogic`);
            }
        },

        artsy: {
            post: function () {
                return Artcloud.router.build(`imports/artsy`);
            }
        },

        artsyConnections: {
            post: function () {
                return Artcloud.router.build(`imports/artsyConnections`);
            }
        },

        artworkArchive: {
            post: function () {
                return Artcloud.router.build(`imports/artworkArchive`);
            }
        },

        clients: {
            post: function () {
                return Artcloud.router.build(`v2/imports/clients`);
            }
        },

        constantContact: {
            post: function () {
                return Artcloud.router.build(`imports/constantContact`);
            }
        },

        csv: {
            get: function (id) {
                return Artcloud.router.build(`imports/${id}/csv`);
            }
        },

        dibs: {
            post: function () {
                return Artcloud.router.build(`v2/imports/dibs`);
            }
        },

        galleryManager: {
            post: function () {
                return Artcloud.router.build(`imports/galleryManager`);
            }
        },

        inventory: {
            post: function () {
                return Artcloud.router.build(`v2/imports/inventory`);
            }
        },

        invoices: {
            post: function () {
                return Artcloud.router.build(`v2/imports/invoices`);
            }
        },

        mailchimp: {
            post: function () {
                return Artcloud.router.build(`imports/mailchimp`);
            }
        },

        masterpiece: {
            post: function () {
                return Artcloud.router.build(`v2/imports/masterpiece`);
            }
        }
    },

    intents: {
        get: () => Artcloud.router.build('intents')
    },

    inventory: {
        get: function () {
            return Artcloud.router.build('v2/inventory');
        },
        post: function () {
            return Artcloud.router.build('v2/inventory');
        },
        put: function (id) {
            return Artcloud.router.build(`inventory/${id}`);
        },

        all: {
            get: function () {
                return Artcloud.router.build('v2/inventory/all');
            }
        },

        documents: {
            get: function (id) {
                return Artcloud.router.build(`inventory/${id}/documents`);
            },
            post: function (id) {
                return Artcloud.router.build(`inventory/${id}/documents`);
            },
            del: function (id, documentId) {
                return Artcloud.router.build(`inventory/${id}/documents/${documentId}`);
            },

            signedUrls: {
                post: function (id, documentId) {
                    return Artcloud.router.build(`inventory/${id}/documents/${documentId}/signedUrls`);
                }
            }
        },

        exports: {
            csv: {
                get: function () {
                    return Artcloud.router.build(`v2/inventory/exports/csv`);
                }
            },
            pdf: {
                get: function () {
                    return Artcloud.router.build(`v2/inventory/exports/pdf`);
                }
            }
        },

        images: {
            get: function (id) {
                return Artcloud.router.build(`inventory/${id}/images`);
            },
            post: function (id) {
                return Artcloud.router.build(`inventory/${id}/images`);
            },
            put: function (id, imageId) {
                return Artcloud.router.build(`inventory/${id}/images/${imageId}`);
            },
            del: function (id, imageId) {
                return Artcloud.router.build(`inventory/${id}/images/${imageId}`);
            },

            order: {
                put: function (id) {
                    return Artcloud.router.build(`inventory/${id}/images/order`);
                }
            },

            signedUrls: {
                post: function (id, imageId) {
                    return Artcloud.router.build(`inventory/${id}/images/${imageId}/signedUrls`);
                }
            }
        },

        items: {
            get: function (id, itemId) {
                return Artcloud.router.build(`v2/inventory/${id}/items/${itemId}`);
            },
            post: function (id) {
                return Artcloud.router.build(`v2/inventory/${id}/items`);
            },
            put: function (id, itemId) {
                return Artcloud.router.build(`v2/inventory/${id}/items/${itemId}`);
            },
            del: function (id, itemId) {
                return Artcloud.router.build(`v2/inventory/${id}/items/${itemId}`);
            },

            expenses: {
                get: function (id, itemId) {
                    return Artcloud.router.build(`inventory/${id}/items/${itemId}/expenses`);
                },
                post: function (id, itemId) {
                    return Artcloud.router.build(`inventory/${id}/items/${itemId}/expenses`);
                },
                put: function (id, itemId, expenseId) {
                    return Artcloud.router.build(`inventory/${id}/items/${itemId}/expenses/${expenseId}`);
                },
                del: function (id, itemId, expenseId) {
                    return Artcloud.router.build(`inventory/${id}/items/${itemId}/expenses/${expenseId}`);
                }
            },

            history: {
                get: function (id, itemId) {
                    return Artcloud.router.build(`v2/inventory/${id}/items/${itemId}/histories`);
                }
            },

            invoices: {
                get: function (id, itemId) {
                    return Artcloud.router.build(`inventory/${id}/items/${itemId}/invoices`);
                },
            },

            unconsign: {
                put: function (id, itemId) {
                    return Artcloud.router.build(`v2/inventory/${id}/items/${itemId}/unconsign`);
                }
            }
        },

        qrCodes: {
            get: function (inventoryId) {
                return Artcloud.router.build(`inventory/${inventoryId}/qrCodes`);
            },
        },

        duplicate: {
            post: function (id) {
                return Artcloud.router.build(`v2/inventory/${id}/duplicate`);
            }
        }
    },

    inventoryTypes: {
        get: function () {
            return Artcloud.router.build('inventoryTypes');
        },
        post: function () {
            return Artcloud.router.build('inventoryTypes');
        },
        del: function (id) {
            return Artcloud.router.build(`inventoryTypes/${id}`);
        }
    },

    invites: {
        get: function () {
            return Artcloud.router.build('invites');
        },
        post: function () {
            return Artcloud.router.build('invites');
        }
    },

    invoiceItems: {
        get: function () {
            return Artcloud.router.build('invoiceItems');
        },

        artistPayments: {
            get: function (id) {
                return Artcloud.router.build(`invoiceItems/${id}/artistPayments`);
            },
            post: function (id) {
                return Artcloud.router.build(`invoiceItems/${id}/artistPayments`);
            },
            put: function (id, artistPaymentId) {
                return Artcloud.router.build(`invoiceItems/${id}/artistPayments/${artistPaymentId}`);
            },
            del: function (id, artistPaymentId) {
                return Artcloud.router.build(`invoiceItems/${id}/artistPayments/${artistPaymentId}`);
            }
        },

        exports: {
            pdf: {
                post: () => Artcloud.router.build('invoiceItems/exports/pdf')
            }
        }
    },

    invoices: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`v2/invoices/${id}`);
            }
            else {
                return Artcloud.router.build('v2/invoices');
            }
        },
        post: function () {
            return Artcloud.router.build('invoices');
        },
        put: function (id) {
            return Artcloud.router.build(`invoices/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`v2/invoices/${id}`);
        },

        commissions: {
            get: function (id) {
                return Artcloud.router.build(`invoices/${id}/commissions`);
            },
            post: function (id) {
                return Artcloud.router.build(`invoices/${id}/commissions`);
            },
            put: function (id, staffId) {
                return Artcloud.router.build(`invoices/${id}/commissions/${staffId}`);
            },
            del: function (id, staffId) {
                return Artcloud.router.build(`invoices/${id}/commissions/${staffId}`);
            }
        },

        credits: {
            post: function (id) {
                return Artcloud.router.build(`invoices/${id}/credits`);
            },
            del: function (id, creditRedeemId) {
                return Artcloud.router.build(`invoices/${id}/credits/${creditRedeemId}`);
            }
        },

        duplicates: {
            post: function (id) {
                return Artcloud.router.build(`invoices/${id}/duplicates`);
            }
        },

        exports: {
            csv: {
                get: function () {
                    return Artcloud.router.build('v2/invoices/exports/csv');
                }
            }
        },

        items: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`v2/invoices/${id}/items`);
                } else {
                    return Artcloud.router.build('invoices/items');
                }
            },
            post: function (id) {
                return Artcloud.router.build(`v2/invoices/${id}/items`);
            },
            put: function (id, itemId) {
                return Artcloud.router.build(`v2/invoices/${id}/items/${itemId}`);
            },
            del: function (id, itemId) {
                return Artcloud.router.build(`v2/invoices/${id}/items/${itemId}`);
            }
        },

        paymentIntents: {
            post: function (invoiceId) {
                return Artcloud.router.build(`invoices/${invoiceId}/paymentIntents`);
            },
            del: function (invoiceId, paymentIntentId) {
                return Artcloud.router.build(`invoices/${invoiceId}/paymentIntents/${paymentIntentId}`);
            },

            captures: {
                post: function (invoiceId) {
                    return Artcloud.router.build(`invoices/${invoiceId}/paymentIntents/captures`);
                }
            },
        },

        payments: {
            get: function (id) {
                return Artcloud.router.build(`invoices/${id}/payments`);
            },
            put: function (id, paymentId) {
                return Artcloud.router.build(`v2/invoices/${id}/payments/${paymentId}`);
            },
            del: function (id, paymentId) {
                return Artcloud.router.build(`invoices/${id}/payments/${paymentId}`);
            },

            cash: {
                post: function (id) {
                    return Artcloud.router.build(`v2/invoices/${id}/payments/cash`);
                }
            },

            refunds: {
                post: function (id, paymentId) {
                    return Artcloud.router.build(`v2/invoices/${id}/payments/${paymentId}/refunds`);
                },
                put: function (id, paymentId, refundId) {
                    return Artcloud.router.build(`v2/invoices/${id}/payments/${paymentId}/refunds/${refundId}`);
                },

                stripe: {
                    post: function (id, paymentId) {
                        return Artcloud.router.build(`v2/invoices/${id}/payments/${paymentId}/refunds/stripe`);
                    }
                }
            },

            stripe: {
                new: {
                    post: function (id) {
                        return Artcloud.router.build(`v2/invoices/${id}/payments/stripe/new`);
                    }
                },
                saved: {
                    post: function (id) {
                        return Artcloud.router.build(`v2/invoices/${id}/payments/stripe/saved`);
                    }
                }
            }
        },

        promoCodes: {
            get: function (id) {
                return Artcloud.router.build(`invoices/${id}/promoCodes`);
            },
            post: function (id) {
                return Artcloud.router.build(`invoices/${id}/promoCodes`);
            },
            del: function (id, invoicePromoCodeId) {
                return Artcloud.router.build(`invoices/${id}/promoCodes/${invoicePromoCodeId}`);
            }
        },

        shipments: {
            get: function (id) {
                return Artcloud.router.build(`invoices/${id}/shipments`);
            },
            post: function (id) {
                return Artcloud.router.build(`invoices/${id}/shipments`);
            }
        },

        taxes: {
            get: function (id) {
                return Artcloud.router.build(`invoices/${id}/taxes`);
            },
            post: function (id) {
                return Artcloud.router.build(`invoices/${id}/taxes`);
            },
            del: function (id, taxRateId) {
                return Artcloud.router.build(`invoices/${id}/taxes/${taxRateId}`);
            }
        }
    },

    invoiceStages: {
        get: function () {
            return Artcloud.router.build('invoiceStages');
        },
        post: function () {
            return Artcloud.router.build('invoiceStages');
        },
        put: function (id) {
            return Artcloud.router.build(`invoiceStages/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`invoiceStages/${id}`);
        },

        orders: {
            put: function () {
                return Artcloud.router.build('invoiceStages/orders');
            }
        }
    },

    lists: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`lists/${id}`);
            }
            else {
                return Artcloud.router.build('lists');
            }
        },
        post: function () {
            return Artcloud.router.build('lists');
        },
        put: function (id) {
            return Artcloud.router.build(`lists/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`lists/${id}`);
        },

        actions: {
            post: function (id) {
                return Artcloud.router.build(`lists/${id}/actions`);
            }
        },

        exports: {
            arcual: {
                get: function (id) {
                    return Artcloud.router.build(`lists/${id}/exports/arcual`);
                }
            },
            artsy: {
                get: function (id) {
                    return Artcloud.router.build(`lists/${id}/exports/artsy`);
                }
            },
            csv: {
                get: function (id) {
                    return Artcloud.router.build(`lists/${id}/exports/csv`);
                }
            },
            dibs: {
                get: function (id) {
                    return Artcloud.router.build(`lists/${id}/exports/dibs`);
                }
            }
        },

        images: {
            get: function (id) {
                return Artcloud.router.build(`lists/${id}/images`);
            },
            post: function (id) {
                return Artcloud.router.build(`lists/${id}/images`);
            },
            del: function (id, imageId) {
                return Artcloud.router.build(`lists/${id}/images/${imageId}`);
            },

            cover: {
                get: function (id) {
                    return Artcloud.router.build(`lists/${id}/images/cover`);
                },
                put: function (id) {
                    return Artcloud.router.build(`lists/${id}/images/cover`);
                },
                del: function (id) {
                    return Artcloud.router.build(`lists/${id}/images/cover`);
                }
            },

            order: {
                put: (id) => {
                    return Artcloud.router.build(`lists/${id}/images/order`);
                }
            }
        },

        items: {
            get: function (id) {
                return Artcloud.router.build(`v2/lists/${id}/items`);
            },
            post: function (id) {
                return Artcloud.router.build(`lists/${id}/items`);
            },
            put: function (id, itemId) {
                if (itemId) {
                    return Artcloud.router.build(`lists/${id}/items/${itemId}`);
                } else {
                    return Artcloud.router.build(`lists/${id}/items`);
                }
            },

            all: {
                get: function (id) {
                    return Artcloud.router.build(`lists/${id}/items/all`);
                },
            },

            batches: {
                post: function (id) {
                    return Artcloud.router.build(`lists/${id}/items/batches`);
                }
            }
        },

        mailchimp: {
            get: function () {
                return Artcloud.router.build(`lists/mailchimp`);
            }
        },

        qrCodes: {
            get: function (quicklistId) {
                return Artcloud.router.build(`lists/${quicklistId}/qrCodes`);
            }
        },
    },

    locations: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`locations/${id}`);
            }
            else {
                return Artcloud.router.build('locations');
            }
        },
        post: function () {
            return Artcloud.router.build('locations');
        },
        put: function (id) {
            return Artcloud.router.build(`locations/${id}`);
        },

        hours: {
            get: function (id) {
                return Artcloud.router.build(`locations/${id}/hours`);
            },
            put: function (id, day) {
                return Artcloud.router.build(`locations/${id}/hours/${day}`);
            },
            del: function (id, day) {
                return Artcloud.router.build(`locations/${id}/hours/${day}`);
            }
        },

        images: {
            logo: {
                get: function (id) {
                    return Artcloud.router.build(`locations/${id}/images/logo`);
                },
                put: function (id) {
                    return Artcloud.router.build(`locations/${id}/images/logo`);
                },
                del: function (id) {
                    return Artcloud.router.build(`locations/${id}/images/logo`);
                }
            }
        },

        taxes: {
            get: function (id) {
                return Artcloud.router.build(`locations/${id}/taxes`);
            },
            post: function (id) {
                return Artcloud.router.build(`locations/${id}/taxes`);
            },
            put: function (id, taxRateId) {
                return Artcloud.router.build(`locations/${id}/taxes/${taxRateId}`);
            },
            del: function (id, taxRateId) {
                return Artcloud.router.build(`locations/${id}/taxes/${taxRateId}`);
            },

            tiers: {
                get: function(id, taxRateId) {
                    return Artcloud.router.build(`locations/${id}/taxes/${taxRateId}/tiers`);
                },
                put: function(id, taxRateId) {
                    return Artcloud.router.build(`locations/${id}/taxes/${taxRateId}/tiers`);
                }
            }
        },
    },

    mailingLists: {
        get: function () {
            return Artcloud.router.build(`mailingLists`);
        }
    },

    marketplace: {
        analytics: {
            graphs: {
                inquiries: {
                    get: function () {
                        return Artcloud.router.build(`marketplace/analytics/graphs/inquiries`);
                    }
                },
                sales: {
                    get: function () {
                        return Artcloud.router.build(`marketplace/analytics/graphs/sales`);
                    }
                },
                follows: {
                    get: function () {
                        return Artcloud.router.build(`marketplace/analytics/graphs/follows`);
                    }
                },
                likes: {
                    get: function () {
                        return Artcloud.router.build(`marketplace/analytics/graphs/likes`);
                    }
                }
            }
        },

        art: {
            get: function () {
                return Artcloud.router.build(`marketplace/art`);
            },

            likes: {
                put: function (id) {
                    return Artcloud.router.build(`marketplace/art/${id}/likes`);
                },
                del: function (id) {
                    return Artcloud.router.build(`marketplace/art/${id}/likes`);
                }
            },

            shares: {
                emails: {
                    post: function (id) {
                        return Artcloud.router.build(`marketplace/art/${id}/shares/emails`);
                    }
                },
                sms: {
                    post: function (id) {
                        return Artcloud.router.build(`marketplace/art/${id}/shares/sms`);
                    }
                }
            }
        },

        artistFollows: {
            get: function () {
                return Artcloud.router.build(`marketplace/artistFollows`);
            },
        },

        follows: {
            get: function () {
                return Artcloud.router.build(`marketplace/follows`);
            },
        },

        galleries: {
            follows: {
                put: function (id) {
                    return Artcloud.router.build(`marketplace/galleries/${id}/follows`);
                },
                del: function (id) {
                    return Artcloud.router.build(`marketplace/galleries/${id}/follows`);
                }
            }
        },

        inquiries: {
            get: function () {
                return Artcloud.router.build(`marketplace/inquiries`);
            },
        },

        likes: {
            get: function () {
                return Artcloud.router.build(`marketplace/likes`);
            },
        },

        shows: {
            shares: {
                sms: {
                    post: function (id) {
                        return Artcloud.router.build(`marketplace/shows/${id}/shares/sms`);
                    }
                }
            }
        },

        tastemaker: {
            art: {
                get: function () {
                    return Artcloud.router.build(`marketplace/tastemaker/art`);
                }
            }
        }
    },

    merges: {
        clients: {
            get: function () {
                return Artcloud.router.build('merges/clients');
            },
            post: function () {
                return Artcloud.router.build('merges/clients');
            }
        }
    },

    messages: {
        get: function () {
            return Artcloud.router.build('messages');
        },
        put: function (id) {
            return Artcloud.router.build(`messages/${id}`);
        },

        attachments: {
            get: function (id, attachmentId) {
                return Artcloud.router.build(`messages/${id}/attachments/${attachmentId}`);
            }
        },

        emails: {
            validations: {
                post: function () {
                    return Artcloud.router.build('messages/emails/validations');
                }
            }
        },

        previews: {
            get: function () {
                return Artcloud.router.build(`messages/previews`);
            }
        }
    },

    newArrivals: {
        list: () => Artcloud.router.build('newArrivals'),
        get: (artistId) => Artcloud.router.build(`newArrivals/${artistId}`),
        put: (artistId) => Artcloud.router.build(`newArrivals/${artistId}`),
        inventory: {
            get: (artistId) => Artcloud.router.build(`newArrivals/${artistId}/inventory`)
        }
    },

    notifications: {
        get: function () {
            return Artcloud.router.build('v2/notifications');
        },
        put: function (type, id) {
            if (type) {
                if (id) {
                    return Artcloud.router.build(`notifications/${type}/${id}`);
                } else {
                    return Artcloud.router.build(`notifications/${type}`);
                }
            } else {
                return Artcloud.router.build('notifications');
            }
        }
    },

    odata: {
        inventory: {
            post: function (prop) {
                return Artcloud.router.build(`odata/inventory/${prop}`);
            }
        }
    },

    onboarding: {
        clients: {
            get: () => Artcloud.router.build(`onboarding/clients`)
        },

        images: {
            cover: {
                get: function () {
                    return Artcloud.router.build('onboarding/profile/images/cover');
                },
                put: function () {
                    return Artcloud.router.build('onboarding/profile/images/cover');
                },
                del: function () {
                    return Artcloud.router.build('onboarding/profile/images/cover');
                }
            },
            logo: {
                get: function () {
                    return Artcloud.router.build('onboarding/profile/images/logo');
                },
                put: function () {
                    return Artcloud.router.build('onboarding/profile/images/logo');
                },
                del: function () {
                    return Artcloud.router.build('onboarding/profile/images/logo');
                }
            },
            profile: {
                get: function () {
                    return Artcloud.router.build('onboarding/profile/images/profile');
                },
                put: function () {
                    return Artcloud.router.build('onboarding/profile/images/profile');
                },
                del: function () {
                    return Artcloud.router.build('onboarding/profile/images/profile');
                }
            }
        },

        samples: {
            get: function (dataSub) {
                if (dataSub) {
                    return Artcloud.router.build(`onboarding/samples/${dataSub}`);
                }
                return Artcloud.router.build(`onboarding/samples`);
            },
            post: function () {
                return Artcloud.router.build('onboarding/samples');
            }
        }
    },

    opportunities: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`opportunities/${id}`);
            } else {
                return Artcloud.router.build('opportunities');
            }
        },
        post: function () {
            return Artcloud.router.build('opportunities');
        },
        put: function (id) {
            return Artcloud.router.build(`opportunities/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`opportunities/${id}`);
        },

        activities: {
            get: function (id) {
                return Artcloud.router.build(`opportunities/${id}/activities`);
            }
        },

        all: {
            get: function () {
                return Artcloud.router.build('opportunities/all');
            }
        },

        boards: {
            get: function () {
                return Artcloud.router.build('opportunities/boards');
            }
        },

        exports: {
            csv: {
                post: function () {
                    return Artcloud.router.build(`opportunities/exports/csv`);
                }
            },
        },

        invoices: {
            get: function (id) {
                return Artcloud.router.build(`opportunities/${id}/invoices`);
            }
        },

        items: {
            get: function (id) {
                return Artcloud.router.build(`opportunities/${id}/items`);
            },
            put: function (id) {
                return Artcloud.router.build(`opportunities/${id}/items`);
            },
            del: function (id, itemId) {
                return Artcloud.router.build(`opportunities/${id}/items/${itemId}`);
            }
        },

        offers: {
            get: function (id) {
                return Artcloud.router.build(`opportunities/${id}/offers`);
            }
        },

        stages: {
            get: function () {
                return Artcloud.router.build('opportunities/stages');
            },
            post: function () {
                return Artcloud.router.build('opportunities/stages');
            },
            put: function (id) {
                return Artcloud.router.build(`opportunities/stages/${id}`);
            },
            del: function (id) {
                return Artcloud.router.build(`opportunities/stages/${id}`);
            },

            orders: {
                put: function () {
                    return Artcloud.router.build('opportunities/stages/orders');
                }
            }
        },

        totals: {
            get: function () {
                return Artcloud.router.build('opportunities/totals');
            }
        }
    },

    promoCodes: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`promoCodes/${id}`);
            } else {
                return Artcloud.router.build('promoCodes');
            }
        },
        post: function () {
            return Artcloud.router.build('promoCodes');
        },
        put: function (id) {
            return Artcloud.router.build(`promoCodes/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`promoCodes/${id}`);
        },
    },

    purchaseOrders: {
        post: () => Artcloud.router.build('purchaseOrders'),

        boards: {
            get: () => {
                return Artcloud.router.build('purchaseOrders/boards');
            }
        },

        exports: {
            csv: {
                get: () => {
                    return Artcloud.router.build('purchaseOrders/exports/csv');
                }
            }
        }
    },

    releaseNotes: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`releaseNotes/${id}`);
            } else {
                return Artcloud.router.build('releaseNotes');
            }
        },
        post: function () {
            return Artcloud.router.build('releaseNotes');
        },
        del: function (id) {
            return Artcloud.router.build(`releaseNotes/${id}`);
        },
        put: function (id) {
            return Artcloud.router.build(`releaseNotes/${id}`);
        }
    },

    reports: {
        approvals: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`reports/approvals/${id}`);
                } else {
                    return Artcloud.router.build('reports/approvals');
                }
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/approvals/exports/csv');
                    }
                },
                pdf: {
                    post: function () {
                        return Artcloud.router.build('reports/approvals/exports/pdf');
                    }
                }
            }
        },
        artistPayments: {
            get: function () {
                return Artcloud.router.build('reports/artistpayments');
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/artistpayments/exports/csv');
                    }
                }
            }
        },
        commissions: {
            get: function () {
                return Artcloud.router.build('reports/commissions');
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/commissions/exports/csv');
                    }
                },
                pdf: {
                    post: function () {
                        return Artcloud.router.build('reports/commissions/exports/pdf');
                    }
                }
            },

            totals: {
                get: function () {
                    return Artcloud.router.build('reports/commissions/totals');
                }
            }
        },
        consignment: {
            get: function (type, id) {
                if (id) {
                    return Artcloud.router.build(`reports/consignment/${type}/${id}`);
                } else {
                    return Artcloud.router.build('reports/consignment');
                }
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/consignment/exports/csv');
                    }
                },
                csvSummary: {
                    post: function () {
                        return Artcloud.router.build('reports/consignment/exports/csvSummary');
                    }
                },
                doc: {
                    post: function () {
                        return Artcloud.router.build('reports/consignment/exports/doc');
                    }
                },
                pdf: {
                    post: function () {
                        return Artcloud.router.build('reports/consignment/exports/pdf');
                    }
                }
            },

            totals: {
                get: function () {
                    return Artcloud.router.build('reports/consignment/totals');
                }
            }
        },
        layaways: {
            get: function () {
                return Artcloud.router.build('reports/layaways');
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/layaways/exports/csv');
                    }
                }
            },

            totals: {
                get: function () {
                    return Artcloud.router.build('reports/layaways/totals');
                }
            }
        },
        payments: {
            get: function () {
                return Artcloud.router.build('reports/payments');
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/payments/exports/csv');
                    }
                },
                pdf: {
                    post: function () {
                        return Artcloud.router.build('reports/payments/exports/pdf');
                    }
                }
            },

            totals: {
                get: function () {
                    return Artcloud.router.build('reports/payments/totals');
                }
            }
        },
        sales: {
            get: function () {
                return Artcloud.router.build('reports/sales');
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/sales/exports/csv');
                    }
                },
                pdf: {
                    post: function () {
                        return Artcloud.router.build('reports/sales/exports/pdf');
                    }
                },
                quickbooks: {
                    post: function () {
                        return Artcloud.router.build('reports/sales/exports/quickbooks');
                    }
                },
                quickbooksOnline: {
                    post: function () {
                        return Artcloud.router.build('reports/sales/exports/quickbooksOnline');
                    }
                }
            },

            graphs: {
                get: function () {
                    return Artcloud.router.build('reports/sales/graphs');
                }
            },

            totals: {
                get: function () {
                    return Artcloud.router.build('reports/sales/totals');
                }
            }
        },
        salesByArtist: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`reports/salesbyartist/${id}`);
                } else {
                    return Artcloud.router.build('reports/salesbyartist');
                }
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/salesbyartist/exports/csv');
                    }
                },
                pdf: {
                    post: function () {
                        return Artcloud.router.build('reports/salesbyartist/exports/pdf');
                    }
                }
            }
        },
        taxes: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`reports/taxes/${id}`);
                } else {
                    return Artcloud.router.build('reports/taxes');
                }
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/taxes/exports/csv');
                    }
                },
                pdf: {
                    post: function () {
                        return Artcloud.router.build('reports/taxes/exports/pdf');
                    }
                }
            },

            totals: {
                get: function () {
                    return Artcloud.router.build('reports/taxes/totals');
                }
            }
        },
        top: {
            get: function () {
                return Artcloud.router.build('reports/top');
            },

            exports: {
                csv: {
                    post: function () {
                        return Artcloud.router.build('reports/top/exports/csv');
                    }
                },
                labels: {
                    post: function () {
                        return Artcloud.router.build('reports/top/exports/labels');
                    }
                }
            }
        }
    },

    representatives: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`representatives/${id}`);
            } else {
                return Artcloud.router.build('representatives');
            }
        },
        post: function () {
            return Artcloud.router.build('representatives');
        },
        put: function (id) {
            return Artcloud.router.build(`representatives/${id}`);
        },

        images: {
            logo: {
                put: function (id) {
                    return Artcloud.router.build(`representatives/${id}/images/logo`);
                }
            }
        }
    },

    salesTips: {
        get: function () {
            return Artcloud.router.build('salesTips');
        },
        post: function () {
            return Artcloud.router.build('salesTips');
        }
    },

    searches: {
        _build: (route, version) => Artcloud.router.build(`${version ? 'v' + version + '/' : ''}searches/${route}`),

        accounts: {
            get: () => Artcloud.router.searches._build('accounts')
        },
        addresses: {
            get: () => Artcloud.router.searches._build('addresses')
        },
        artists: {
            get: () => Artcloud.router.searches._build('artists')
        },
        audiencesV2: {
            get: () => Artcloud.router.searches._build('audiences', '2')
        },
        blogs: {
            get: () => Artcloud.router.searches._build('blogs')
        },
        campaigns: {
            get: () => Artcloud.router.searches._build('campaigns')
        },
        contacts: {
            get: () => Artcloud.router.searches._build('contacts')
        },
        editions: {
            get: () => Artcloud.router.searches._build('editions')
        },
        editionSets: {
            get: () => Artcloud.router.searches._build('editionSets')
        },
        inventoryV2: {
            get: () => Artcloud.router.searches._build('inventory', '2')
        },
        promoCodes: {
            get: () => Artcloud.router.searches._build('promoCodes')
        },
        tags: {
            get: () => Artcloud.router.searches._build('tags')
        },
        websitePages: {
            get: () => Artcloud.router.searches._build('websitePages')
        },
        websiteRedirects: {
            get: () => Artcloud.router.searches._build('websiteRedirects')
        },

        artistsV2: {
            get: function () {
                return Artcloud.router.build('v2/searches/artists');
            }
        },
        audiences: {
            get() {
                return Artcloud.router.build('searches/audiences');
            }
        },
        clients: {
            get: function () {
                return Artcloud.router.build('searches/clients');
            }
        },
        collateral: {
            get: function () {
                return Artcloud.router.build('searches/collateral');
            }
        },
        consignersV2: {
            get: function () {
                return Artcloud.router.build('v2/searches/consigners');
            }
        },
        consignmentsV2: {
            get: function () {
                return Artcloud.router.build('v2/searches/consignments');
            }
        },
        consignmentSales: {
            get: function () {
                return Artcloud.router.build('searches/consignmentSales');
            }
        },
        currencies: {
            get: function () {
                return Artcloud.router.build('searches/currencies');
            }
        },
        editionTitles: {
            get: function () {
                return Artcloud.router.build('searches/editionTitles');
            }
        },
        inventory: {
            get: function () {
                return Artcloud.router.build('searches/inventory');
            }
        },
        invoices: {
            get: function () {
                return Artcloud.router.build('searches/invoices');
            }
        },
        opportunities: {
            get() {
                return Artcloud.router.build('searches/opportunities');
            }
        },
        pages: {
            get: function () {
                return Artcloud.router.build('searches/pages');
            }
        },
        purchaseOrders: {
            get() {
                return Artcloud.router.build('searches/purchaseOrders');
            }
        },
        quicklists: {
            get: function () {
                return Artcloud.router.build('searches/quicklists');
            }
        },
        recipients: {
            get: function () {
                return Artcloud.router.build('searches/recipients');
            }
        },
        reports: {
            get: function () {
                return Artcloud.router.build('searches/reports');
            }
        },
        staff: {
            get: function () {
                return Artcloud.router.build('searches/staff');
            },

            emails: {
                get: function () {
                    return Artcloud.router.build('searches/staff/emails');
                }
            }
        },
    },

    secondaryMarket: {
        get: function () {
            return Artcloud.router.build('v2/inventory');
        }
    },

    sessions: {
        get: function () {
            return Artcloud.router.build('sessions');
        },

        tokens: {
            get: function () {
                return Artcloud.router.build('sessions/tokens');
            },

            canny: {
                get: function () {
                    return Artcloud.router.build('sessions/tokens/canny');
                }
            }
        }
    },

    settings: {
        collateral: {
            get: function () {
                return Artcloud.router.build('settings/collateral');
            },
            put: function () {
                return Artcloud.router.build('settings/collateral');
            }
        },

        config: {
            get: function () {
                return Artcloud.router.build('settings/config');
            },
            put: function () {
                return Artcloud.router.build('settings/config');
            }
        },

        currencyRates: {
            get: function () {
                return Artcloud.router.build('settings/currencyRates');
            },
            post: function () {
                return Artcloud.router.build('settings/currencyRates');
            },
            put: function (id) {
                return Artcloud.router.build(`settings/currencyRates/${id}`);
            },
            del: function (id) {
                return Artcloud.router.build(`settings/currencyRates/${id}`);
            }
        },

        integrations: {
            get: function () {
                return Artcloud.router.build('settings/integrations');
            },
            put: function () {
                return Artcloud.router.build('settings/integrations');
            },

            permissions: {
                get: () => Artcloud.router.build(`settings/integrations/permissions`)
            },

            shippo: {
                put: function () {
                    return Artcloud.router.build('settings/integrations/shippo');
                }
            },

            stripeExpress: {
                links: {
                    get: function () {
                        return Artcloud.router.build('settings/integrations/stripeexpress/links');
                    }
                }
            }
        },

        marketplace: {
            get: function () {
                return Artcloud.router.build('settings/marketplace');
            },
            put: function () {
                return Artcloud.router.build('settings/marketplace');
            }
        },

        notifications: {
            get: function () {
                return Artcloud.router.build('settings/notifications');
            },
            put: function () {
                return Artcloud.router.build('settings/notifications');
            }
        },

        profile: {
            get: function () {
                return Artcloud.router.build('settings/profile');
            },
            put: function () {
                return Artcloud.router.build('settings/profile');
            },

            gmail: {
                del: function () {
                    return Artcloud.router.build('settings/profile/gmail');
                }
            },

            outlook: {
                del: function () {
                    return Artcloud.router.build('settings/profile/outlook');
                }
            }
        },

        socials: {
            get: function () {
                return Artcloud.router.build('settings/socials');
            },
            put: function () {
                return Artcloud.router.build('settings/socials');
            }
        },

        subscription: {
            get: function () {
                return Artcloud.router.build('settings/subscription');
            },
            put: function () {
                return Artcloud.router.build('settings/subscription');
            },

            billing: {
                get: function () {
                    return Artcloud.router.build('settings/subscription/billing');
                },

                exports: {
                    pdf: {
                        get: function (id) {
                            return Artcloud.router.build(`settings/subscription/billing/${id}/exports/pdf`);
                        }
                    }
                }
            },

            method: {
                get: function () {
                    return Artcloud.router.build('settings/subscription/method');
                },
                put: function () {
                    return Artcloud.router.build('settings/subscription/method');
                }
            },

            trial: {
                put: function () {
                    return Artcloud.router.build('settings/subscription/trial');
                }
            }
        },
    },

    shipments: {
        post: function () {
            return Artcloud.router.build('shipments');
        }
    },

    slugs: {
        artists: {
            put: function (id) {
                return Artcloud.router.build(`slugs/artists/${id}`);
            }
        },

        inventory: {
            put: function (id) {
                return Artcloud.router.build(`slugs/inventory/${id}`);
            }
        },

        quicklists: {
            put: function (id) {
                return Artcloud.router.build(`slugs/quicklists/${id}`);
            }
        }
    },

    social: {
        inventory: {
            shares: {
                sms: {
                    post: function (id) {
                        return Artcloud.router.build(`social/inventory/${id}/shares/sms`);
                    }
                }
            }
        },
        quicklists: {
            shares: {
                sms: {
                    post: function (id) {
                        return Artcloud.router.build(`social/quicklists/${id}/shares/sms`);
                    }
                }
            }
        }
    },

    staff: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`staff/${id}`);
            }
            else {
                return Artcloud.router.build('v2/staff');
            }
        },
        post: function () {
            return Artcloud.router.build('staff');
        },
        put: function (id) {
            return Artcloud.router.build(`staff/${id}`);
        },

        images: {
            profile: {
                get: function (id) {
                    return Artcloud.router.build(`staff/${id}/images/profile`);
                },
                put: function (id) {
                    return Artcloud.router.build(`staff/${id}/images/profile`);
                },
                del: function (id) {
                    return Artcloud.router.build(`staff/${id}/images/profile`);
                }
            }
        }
    },

    stripe: {
        locations: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`stripe/locations/${id}`);
                }
                return Artcloud.router.build('stripe/locations');
            },
            post: function () {
                return Artcloud.router.build('stripe/locations');
            },
            put: function (id) {
                return Artcloud.router.build(`stripe/locations/${id}`);
            },

            connectionTokens: {
                post: function (id) {
                    return Artcloud.router.build(`stripe/locations/${id}/connectionTokens`);
                },
            },

            readers: {
                get: function (id) {
                    return Artcloud.router.build(`stripe/locations/${id}/readers`);
                },
                post: function (id) {
                    return Artcloud.router.build(`stripe/locations/${id}/readers`);
                },
                put: function (id, readerId) {
                    return Artcloud.router.build(`stripe/locations/${id}/readers/${readerId}`);
                }
            }
        },

        promotionCodes: {
            get: function () {
                return Artcloud.router.build('stripe/promotionCodes');
            }
        }
    },

    tags: {
        get: function (type) {
            return Artcloud.router.build(`tags/${type}`);
        },
        put: function (type, id) {
            return Artcloud.router.build(`tags/${type}?id=${id}`);
        },
        del: function (type, id) {
            return Artcloud.router.build(`tags/${type}?id=${id}`);
        }
    },

    terms: {
        get: function () {
            return Artcloud.router.build('terms');
        },
        post: function () {
            return Artcloud.router.build('terms');
        }
    },

    themes: {
        get: function (id) {
            if (id) {
                return Artcloud.router.build(`themes/${id}`);
            } else {
                return Artcloud.router.build('themes');
            }
        },
        post: function () {
            return Artcloud.router.build('themes');
        },
        put: function (id) {
            return Artcloud.router.build(`themes/${id}`);
        },

        images: {
            get: function (id) {
                return Artcloud.router.build(`themes/${id}/images`);
            },
            post: function (id) {
                return Artcloud.router.build(`themes/${id}/images`);
            },
            del: function (id, imageId) {
                return Artcloud.router.build(`themes/${id}/images/${imageId}`);
            }
        }
    },

    threads: {
        post: function () {
            return Artcloud.router.build('threads');
        },
        messages: {
            post: function (id) {
                return Artcloud.router.build(`threads/${id}/messages`);
            }
        },
        signatures: {
            me: {
                get: function () {
                    return Artcloud.router.build('threads/signatures/me');
                },
                put: function () {
                    return Artcloud.router.build('threads/signatures/me');
                }
            }
        }
    },

    todos: {
        get: function () {
            return Artcloud.router.build('v2/todos');
        },
        post: function () {
            return Artcloud.router.build('todos');
        },
        put: function (id) {
            return Artcloud.router.build(`todos/${id}`);
        },
        del: function (id) {
            return Artcloud.router.build(`todos/${id}`);
        },

        exports: {
            pdf: {
                post: function() {
                    return Artcloud.router.build('todos/exports/pdf');
                }
            }
        }
    },

    website: {
        blocks: {
            images: {
                post: function () {
                    return Artcloud.router.build(`website/blocks/images`);
                }
            },

            tabs: {
                post: function (id) {
                    return Artcloud.router.build(`website/blocks/${id}/tabs`);
                }
            }
        },

        images: {
            get: function () {
                return Artcloud.router.build(`website/images`);
            },
            post: function () {
                return Artcloud.router.build(`website/images`);
            },
            del: function (id) {
                return Artcloud.router.build(`website/images/${id}`);
            },

            favicon: {
                put: function () {
                    return Artcloud.router.build(`website/images/favicon`);
                },
                del: function () {
                    return Artcloud.router.build(`website/images/favicon`);
                }
            },

            logo: {
                get: function () {
                    return Artcloud.router.build(`website/images/logo`);
                },
                put: function () {
                    return Artcloud.router.build(`website/images/logo`);
                },
                del: function () {
                    return Artcloud.router.build(`website/images/logo`);
                }
            }
        },

        pages: {
            get: function (id) {
                if (id) {
                    return Artcloud.router.build(`website/pages/${id}`);
                } else {
                    return Artcloud.router.build(`v2/website/pages`);
                }
            },
            post: function () {
                return Artcloud.router.build(`v2/website/pages`);
            },
            put: function (id) {
                return Artcloud.router.build(`website/pages/${id}`);
            },
            del: function (id) {
                return Artcloud.router.build(`website/pages/${id}`);
            },

            blocks: {
                get: function (id) {
                    return Artcloud.router.build(`website/pages/${id}/blocks`);
                },
                post: function (id) {
                    return Artcloud.router.build(`website/pages/${id}/blocks`);
                },
                del: function (id, blockId) {
                    return Artcloud.router.build(`website/pages/${id}/blocks/${blockId}`);
                },

                config: {
                    artists: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/artists/${blockId}/config`);
                        }
                    },
                    blogs: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/blogs/${blockId}/config`);
                        }
                    },
                    contact: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/contact/${blockId}/config`);
                        }
                    },
                    custom: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/custom/${blockId}/config`);
                        }
                    },
                    lightbox: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/lightboxes/${blockId}/config`);
                        }
                    },
                    inventory: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/inventory/${blockId}/config`);
                        }
                    },
                    media: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/media/${blockId}/config`);
                        }
                    },
                    shows: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/shows/${blockId}/config`);
                        }
                    },
                    showsparallax: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/shows/${blockId}/config`);
                        }
                    },
                    slider: {
                        put: function (id, blockId) {
                            return Artcloud.router.build(`website/pages/${id}/blocks/sliders/${blockId}/config`);
                        }
                    }
                },

                images: {
                    get: function (id, blockId) {
                        return Artcloud.router.build(`website/pages/${id}/blocks/${blockId}/images`);
                    }
                },

                order: {
                    put: function (id) {
                        return Artcloud.router.build(`website/pages/${id}/blocks/order`);
                    }
                }
            },

            duplicates: {
                post: function (id) {
                    return Artcloud.router.build(`website/pages/${id}/duplicates`);
                }
            },

            dynamic: {
                blocks: {
                    get: function (type) {
                        return Artcloud.router.build(`website/pages/dynamic/${type}/blocks`);
                    },
                    post: function (type) {
                        return Artcloud.router.build(`website/pages/dynamic/${type}/blocks`);
                    },
                    put: function (type, blockType, blockId) {
                        return Artcloud.router.build(`website/pages/dynamic/${type}/blocks/${blockType}/${blockId}`);
                    },
                    del: function (type, blockId) {
                        return Artcloud.router.build(`website/pages/dynamic/${type}/blocks/${blockId}`);
                    },

                    images: {
                        get: function (type, blockId) {
                            return Artcloud.router.build(`website/pages/dynamic/${type}/blocks/${blockId}/images`);
                        }
                    },

                    order: {
                        put: function (type) {
                            return Artcloud.router.build(`website/pages/dynamic/${type}/blocks/order`);
                        }
                    }
                }
            },

            order: {
                get: function () {
                    return Artcloud.router.build(`website/pages/order`);
                },
                put: function () {
                    return Artcloud.router.build(`website/pages/order`);
                }
            },

            qr: {
                get: function (id) {
                    return Artcloud.router.build(`website/pages/${id}/qrCodes`);
                }
            }
        },

        settings: {
            get: function () {
                return Artcloud.router.build(`website/settings`);
            },
            put: function () {
                return Artcloud.router.build(`website/settings`);
            },

            design: {
                get: function () {
                    return Artcloud.router.build(`website/settings/design`);
                },
                put: function () {
                    return Artcloud.router.build(`website/settings/design`);
                }
            }
        },

        tabs: {
            get: function (id) {
                return Artcloud.router.build(`website/tabs/${id}`);
            },
            put: function () {
                return Artcloud.router.build(`website/tabs`);
            },
            del: function (id) {
                return Artcloud.router.build(`website/tabs/${id}`);
            },

            blocks: {
                put: function (id) {
                    return Artcloud.router.build(`website/tabs/${id}/blocks`);
                }
            }
        }
    },

    websiteRedirects: {
        get: function () {
            return Artcloud.router.build(`websiteRedirects`);
        },
        post: function () {
            return Artcloud.router.build(`websiteRedirects`);
        },
        del: function (id) {
            return Artcloud.router.build(`websiteRedirects/${id}`);
        }
    },

    websites: {
        configs: {
            get: function (type) {
                return Artcloud.router.build(`websites/configs/${type}`);
            },
            put: function (type) {
                return Artcloud.router.build(`websites/configs/${type}`);
            }
        },

        emailTemplates: {
            configs: {
                get: function (type) {
                    return Artcloud.router.build(`websites/emailTemplates/configs/${type}`);
                },
                put: function (type) {
                    return Artcloud.router.build(`websites/emailTemplates/configs/${type}`);
                }
            },

            data: {
                get: function (type) {
                    return Artcloud.router.build(`websites/emailTemplates/data/${type}`);
                }
            },

            previews: {
                post: function (type) {
                    return Artcloud.router.build(`websites/emailTemplates/previews/${type}`);
                }
            }
        },

        fonts: {
            get: function () {
                return Artcloud.router.build('websites/fonts');
            },
            post: function () {
                return Artcloud.router.build('websites/fonts');
            }
        },

        pages: {
            configs: {
                put: function (id) {
                    return Artcloud.router.build(`websites/pages/${id}/configs`);
                }
            }
        },

        settings: {
            get: function () {
                return Artcloud.router.build('websites/settings');
            }
        }
    }
};

Artcloud.array = {
    toSet: function (arr) {
        const set = new Set();
        arr.forEach(function (item) {
            set.add(item);
        });
        return set;
    },

    insert: (arr, index, newItem) => [
        ...arr.slice(0, index),
        newItem,
        ...arr.slice(index)
    ]
}

Artcloud.format = {
    _round(value, decimals) {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    },

    currency: {
        _addSymbol(stringValue, currencySymbol, currencySymbolPlacement) {
            switch (currencySymbolPlacement) {
                case 1:
                    return currencySymbol + stringValue;
                case 2:
                    return stringValue + currencySymbol;
            }
        },
        fromNumber(value, session) {
            let stringValue = '0.00';
            if (!session || !session.Config) {
                return stringValue;
            }
            const currencySymbol = session.Config.CurrencySymbol;
            let currencySymbolPlacement = 1;
            let decimal = '.';
            let thousands = ',';
            if (session.Config.Currency) {
                currencySymbolPlacement = session.Config.Currency.SymbolPlacement;
                decimal = session.Config.Currency.DecimalSeparator;
                thousands = session.Config.Currency.ThousandsSeperator;
            }
            if (isNaN(value)) {
                return Artcloud.format.currency._addSymbol(stringValue, currencySymbol, currencySymbolPlacement);
            }
            const rounded = Artcloud.format._round(value, 2);
            if (rounded == 0) {
                return Artcloud.format.currency._addSymbol(stringValue, currencySymbol, currencySymbolPlacement);
            }
            const components = rounded.toFixed(2).split('.');
            const array = [...components[0]].reverse();
            stringValue = '';
            for (let i = 0; i < array.length; i++) {
                if (i > 0 && i % 3 == 0) {
                    stringValue = thousands + stringValue;
                }
                stringValue = array[i] + stringValue;
            }
            if (components.length > 1) {
                stringValue += decimal + components[1];
            }
            return Artcloud.format.currency._addSymbol(stringValue, currencySymbol, currencySymbolPlacement);
        }
    }
}

Artcloud.linq = {
    single: function (arr, prop, val) {
        if (!arr || !arr.filter) {
            return undefined;
        }
        return arr.filter(function (e) {
            return e[prop] == val;
        })[0];
    }
}

Artcloud.string = {
    contains: function (str, val) {
        if (str && val) {
            return str.toLowerCase().includes(val.toLowerCase());
        }
        return false;
    }
};

Artcloud.react = {
    views: {
        handlePrevious(state) {
            let q = state.q;
            const offset = q.offset - q.limit;
            if (q.offset === 0) {
                return q;
            }

            q.offset = offset;
            return q;
        },

        handleNext(state) {
            let q = state.q;
            const total = state.data.filtered;
            const offset = q.offset + q.limit;
            if (offset >= total) {
                return q;
            }

            q.offset = offset;
            return q;
        },

        handleSort(state, data) {
            let q = state.q;
            let dir = q.dir;
            if (q.order === data.order) {
                // Toggle direction
                dir = dir == 1 ? 0 : 1;
            } else {
                dir = data.dir != undefined ? data.dir : 0
            }
            q.offset = 0;
            q.dir = dir;
            q.order = data.order;
            return q;
        }
    },

    common: {
        tables: {
            totals: function (props) {
                const total = props.data.filtered;
                let offset = (props.q.offset + 1);
                if (total === 0) {
                    offset = 0;
                }
                let limit = (offset + props.q.limit - 1);
                if (limit > total) {
                    limit = total;
                }
                return {
                    total,
                    offset,
                    limit
                };
            }
        }
    }
}

Artcloud.fullstory = {
    event: function (eventName, eventProperties) {
        if (window.FS) {
            try {
                FS.event(eventName, eventProperties);
            } catch (e) { }
        }
    }
}

module.exports = Artcloud;

//polyfills
if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}
if (!Object.entries) {
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array
        while (i--)
            resArray[i] = [ownProps[i], obj[ownProps[i]]];

        return resArray;
    };
}
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        return this.substr(position || 0, searchString.length) === searchString;
    };
}

// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
    Array.from = (function () {
        var toStr = Object.prototype.toString;
        var isCallable = function (fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        var toInteger = function (value) {
            var number = Number(value);
            if (isNaN(number)) { return 0; }
            if (number === 0 || !isFinite(number)) { return number; }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function (value) {
            var len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike/*, mapFn, thisArg */) {
            // 1. Let C be the this value.
            var C = this;

            // 2. Let items be ToObject(arrayLike).
            var items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError('Array.from requires an array-like object - not null or undefined');
            }

            // 4. If mapfn is undefined, then let mapping be false.
            var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            var T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            var len = toLength(items.length);

            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method 
            // of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            var A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            var k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            var kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }());
}

if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            var len = o.length >>> 0;
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var thisArg = arguments[1];
            var k = 0;
            while (k < len) {
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                k++;
            }
            return undefined;
        }
    });
}
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (searchElement, fromIndex) {
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            var len = o.length >>> 0;
            if (len === 0) {
                return false;
            }
            var n = fromIndex | 0;
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }
            while (k < len) {
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                k++;
            }
            return false;
        }
    });
}
